import {
  otaAbortInstallDe,
  otaAbortInstallEn,
  otaAbortInstallPtBr,
  otaAbortInstallEs,
  otaAbortInstallIt,
  otaAbortInstallZhHans,
  otaAbortInstallNl,
  otaAbortInstallTr,
} from "./ota-abort-install.i18n";
import {
  addNewGatewayDrawerModalDe,
  addNewGatewayDrawerModalEn,
  addNewGatewayDrawerModalPtBr,
  addNewGatewayDrawerModalEs,
  addNewGatewayDrawerModalIt,
  addNewGatewayDrawerModalZhHans,
  addNewGatewayDrawerModalNl,
  addNewGatewayDrawerModalTr,
} from "./add-new-gateway-drawer-modal.i18n";

import {
  addNewMachineDrawerModalDe,
  addNewMachineDrawerModalEn,
  addNewMachineDrawerModalPtBr,
  addNewMachineDrawerModalEs,
  addNewMachineDrawerModalIt,
  addNewMachineDrawerModalZhHans,
  addNewMachineDrawerModalNl,
  addNewMachineDrawerModalTr,
} from "./add-new-machine-drawer-modal.i18n";
import {
  checkBoxTextWrapperDe,
  checkBoxTextWrapperEn,
  checkBoxTextWrapperPtBr,
  checkBoxTextWrapperEs,
  checkBoxTextWrapperIt,
  checkBoxTextWrapperZhHans,
  checkBoxTextWrapperNl,
  checkBoxTextWrapperTr,
} from "./check-box-text-wrapper.i18n";
import {
  dashboardCardDe,
  dashboardCardEn,
  dashboardCardPtBr,
  dashboardCardEs,
  dashboardCardIt,
  dashboardCardZhHans,
  dashboardCardTr,
  dashboardCardNl,
} from "./dashboard-card.i18n";
import {
  dashboardTileGridDe,
  dashboardTileGridEn,
  dashboardTileGridPtBr,
  dashboardTileGridEs,
  dashboardTileGridIt,
  dashboardTileGridZhHans,
  dashboardTileGridTr,
  dashboardTileGridNl,
} from "./dashboard-tile-grid.i18n";
import {
  dashboardThemeEditorDe,
  dashboardThemeEditorEn,
  dashboardThemeEditorPtBr,
  dashboardThemeEditorEs,
  dashboardThemeEditorIt,
  dashboardThemeEditorZhHans,
  dashboardThemeEditorTr,
  dashboardThemeEditorNl,
} from "./dashboard-theme-editor.i18n";
import {
  nameOurNodeDe,
  nameOurNodeEn,
  nameOurNodePtBr,
  nameOurNodeEs,
  nameOurNodeIt,
  nameOurNodeZhHans,
  nameOurNodeNl,
  nameOurNodeTr,
} from "./name-our-node.i18n";
import {
  readOnlyConnectedSourceViewDe,
  readOnlyConnectedSourceViewEn,
  readOnlyConnectedSourceViewPtBr,
  readOnlyConnectedSourceViewEs,
  readOnlyConnectedSourceViewIt,
  readOnlyConnectedSourceViewZhHans,
  readOnlyConnectedSourceViewNl,
  readOnlyConnectedSourceViewTr,
} from "./read-only-connected-source-view.i18n";
import {
  alarmListHeaderDe,
  alarmListHeaderEn,
  alarmListHeaderPtBr,
  alarmListHeaderEs,
  alarmListHeaderIt,
  alarmListHeaderZhHans,
  alarmListHeaderNl,
  alarmListHeaderTr,
} from "./alarm-list-header.i18n";
import {
  alarmListToolbarDe,
  alarmListToolbarEn,
  alarmListToolbarPtBr,
  alarmListToolbarEs,
  alarmListToolbarIt,
  alarmListToolbarZhHans,
  alarmListToolbarNl,
  alarmListToolbarTr,
} from "./alarm-list-toolbar.i18n";
import {
  alarmNodeDetailsPanelDe,
  alarmNodeDetailsPanelEn,
  alarmNodeDetailsPanelPtBr,
  alarmNodeDetailsPanelEs,
  alarmNodeDetailsPanelIt,
  alarmNodeDetailsPanelZhHans,
  alarmNodeDetailsPanelNl,
  alarmNodeDetailsPanelTr,
} from "./alarm-node-details-panel.i18n";
import {
  alarmProfilesDrawerModalDe,
  alarmProfilesDrawerModalEn,
  alarmProfilesDrawerModalPtBr,
  alarmProfilesDrawerModalEs,
  alarmProfilesDrawerModalIt,
  alarmProfilesDrawerModalZhHans,
  alarmProfilesDrawerModalNl,
  alarmProfilesDrawerModalTr,
} from "./alarm-profiles-drawer-modal.i18n";
import {
  blueprintStateInfoBannerModalsButtonsWrapperDe,
  blueprintStateInfoBannerModalsButtonsWrapperEn,
  blueprintStateInfoBannerModalsButtonsWrapperPtBr,
  blueprintStateInfoBannerModalsButtonsWrapperEs,
  blueprintStateInfoBannerModalsButtonsWrapperIt,
  blueprintStateInfoBannerModalsButtonsWrapperZhHans,
  blueprintStateInfoBannerModalsButtonsWrapperNl,
  blueprintStateInfoBannerModalsButtonsWrapperTr,
} from "./blueprint-state-info-banner-modals-buttons-wrapper.i18n";
import {
  checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertDe,
  checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertEn,
  checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertPtBr,
  checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertEs,
  checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertIt,
  checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertZhHans,
  checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertNl,
  checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertTr,
} from "./check-if-structure-has-duplicated-ids-trigger-error-snackbar-and-send-sentry-alert.i18n";
import {
  copyAccessTokenLinkDe,
  copyAccessTokenLinkEn,
  copyAccessTokenLinkPtBr,
  copyAccessTokenLinkEs,
  copyAccessTokenLinkIt,
  copyAccessTokenLinkZhHans,
  copyAccessTokenLinkNl,
  copyAccessTokenLinkTr,
} from "./copy-access-token-link.i18n";
import {
  customerNamespaceStringDe,
  customerNamespaceStringEn,
  customerNamespaceStringPtBr,
  customerNamespaceStringEs,
  customerNamespaceStringIt,
  customerNamespaceStringZhHans,
  customerNamespaceStringNl,
  customerNamespaceStringTr,
} from "./customer-namespace-string.i18n";
import {
  dashboardPanelDe,
  dashboardPanelEn,
  dashboardPanelPtBr,
  dashboardPanelEs,
  dashboardPanelIt,
  dashboardPanelZhHans,
  dashboardPanelNl,
  dashboardPanelTr,
} from "./dashboard-panel.i18n";
import {
  enableDisableAllBlueprintDashboardTogglesDe,
  enableDisableAllBlueprintDashboardTogglesEn,
  enableDisableAllBlueprintDashboardTogglesPtBr,
  enableDisableAllBlueprintDashboardTogglesEs,
  enableDisableAllBlueprintDashboardTogglesIt,
  enableDisableAllBlueprintDashboardTogglesZhHans,
  enableDisableAllBlueprintDashboardTogglesNl,
  enableDisableAllBlueprintDashboardTogglesTr,
} from "./enable-disable-all-blueprint-dashboard-toggles.i18n";
import {
  helpButtonDe,
  helpButtonEn,
  helpButtonPtBr,
  helpButtonEs,
  helpButtonIt,
  helpButtonZhHans,
  helpButtonNl,
  helpButtonTr,
} from "./help-button.i18n";
import {
  gatewaysListHeaderDe,
  gatewaysListHeaderEn,
  gatewaysListHeaderPtBr,
  gatewaysListHeaderEs,
  gatewaysListHeaderIt,
  gatewaysListHeaderZhHans,
  gatewaysListHeaderNl,
  gatewaysListHeaderTr,
} from "./gateways-list-header.i18n";
import {
  gatewaysListViewDe,
  gatewaysListViewEn,
  gatewaysListViewPtBr,
  gatewaysListViewEs,
  gatewaysListViewIt,
  gatewaysListViewZhHans,
  gatewaysListViewNl,
  gatewaysListViewTr,
} from "./gateways-list-view.i18n";
import {
  logoutTimerDe,
  logoutTimerEn,
  logoutTimerPtBr,
  logoutTimerEs,
  logoutTimerIt,
  logoutTimerZhHans,
  logoutTimerNl,
  logoutTimerTr,
} from "./logout-timer.i18n";
import {
  navigationDe,
  navigationEn,
  navigationPtBr,
  navigationEs,
  navigationIt,
  navigationZhHans,
  navigationNl,
  navigationTr,
} from "./navigation.i18n";
import {
  adminPanelSidebarDe,
  adminPanelSidebarEn,
  adminPanelSidebarPtBr,
  adminPanelSidebarEs,
  adminPanelSidebarIt,
  adminPanelSidebarZhHans,
  adminPanelSidebarNl,
  adminPanelSidebarTr,
} from "./admin-panel-sidebar.i18n";
import {
  organizationsViewAdminPanelDe,
  organizationsViewAdminPanelEn,
  organizationsViewAdminPanelPtBr,
  organizationsViewAdminPanelEs,
  organizationsViewAdminPanelIt,
  organizationsViewAdminPanelZhHans,
  organizationsViewAdminPanelNl,
  organizationsViewAdminPanelTr,
} from "./organizations-view-admin-panel.module.i18n";
import {
  addMachineGroupsAdminPanelModalDe,
  addMachineGroupsAdminPanelModalEn,
  addMachineGroupsAdminPanelModalPtBr,
  addMachineGroupsAdminPanelModalEs,
  addMachineGroupsAdminPanelModalIt,
  addMachineGroupsAdminPanelModalZhHans,
  addMachineGroupsAdminPanelModalNl,
  addMachineGroupsAdminPanelModalTr,
} from "./add-machine-groups-admin-panel-modal.i18n";
import {
  cleanupViewAdminPanelDe,
  cleanupViewAdminPanelEn,
  cleanupViewAdminPanelPtBr,
  cleanupViewAdminPanelEs,
  cleanupViewAdminPanelIt,
  cleanupViewAdminPanelZhHans,
  cleanupViewAdminPanelNl,
  cleanupViewAdminPanelTr,
} from "./cleanup-view-admin-panel.i18n";
import {
  machineGroupsViewAdminPanelDe,
  machineGroupsViewAdminPanelEn,
  machineGroupsViewAdminPanelPtBr,
  machineGroupsViewAdminPanelEs,
  machineGroupsViewAdminPanelIt,
  machineGroupsViewAdminPanelZhHans,
  machineGroupsViewAdminPanelNl,
  machineGroupsViewAdminPanelTr,
} from "./machine-groups-view-admin-panel.i18n";
import {
  machineGroupsListAdminPanelDe,
  machineGroupsListAdminPanelEn,
  machineGroupsListAdminPanelPtBr,
  machineGroupsListAdminPanelEs,
  machineGroupsListAdminPanelIt,
  machineGroupsListAdminPanelZhHans,
  machineGroupsListAdminPanelNl,
  machineGroupsListAdminPanelTr,
} from "./machine-groups-list-admin-panel.i18n";
import {
  machineGroupExpandedViewDe,
  machineGroupExpandedViewEn,
  machineGroupExpandedViewPtBr,
  machineGroupExpandedViewEs,
  machineGroupExpandedViewIt,
  machineGroupExpandedViewZhHans,
  machineGroupExpandedViewNl,
  machineGroupExpandedViewTr,
} from "./machine-group-expanded-view.i18n";
import {
  organizationsTableAdminPanelDe,
  organizationsTableAdminPanelEn,
  organizationsTableAdminPanelPtBr,
  organizationsTableAdminPanelEs,
  organizationsTableAdminPanelIt,
  organizationsTableAdminPanelZhHans,
  organizationsTableAdminPanelNl,
  organizationsTableAdminPanelTr,
} from "./organizations-table-admin-panel.i18n";
import {
  adminPanelPageDe,
  adminPanelPageEn,
  adminPanelPagePtBr,
  adminPanelPageEs,
  adminPanelPageIt,
  adminPanelPageZhHans,
  adminPanelPageNl,
  adminPanelPageTr,
} from "./admin-panel-page.i18n";
import {
  newTransferConfigurationToClientDe,
  newTransferConfigurationToClientEn,
  newTransferConfigurationToClientPtBr,
  newTransferConfigurationToClientEs,
  newTransferConfigurationToClientIt,
  newTransferConfigurationToClientZhHans,
  newTransferConfigurationToClientNl,
  newTransferConfigurationToClientTr,
} from "./new-transfer-configuration-to-client.i18n";
import {
  nodeManagerInfoBarPillsNavDe,
  nodeManagerInfoBarPillsNavEn,
  nodeManagerInfoBarPillsNavPtBr,
  nodeManagerInfoBarPillsNavEs,
  nodeManagerInfoBarPillsNavIt,
  nodeManagerInfoBarPillsNavZhHans,
  nodeManagerInfoBarPillsNavNl,
  nodeManagerInfoBarPillsNavTr,
} from "./node-manager-info-bar-pills-nav.i18n";
import {
  pleaseWaitWhileProcessingDe,
  pleaseWaitWhileProcessingEn,
  pleaseWaitWhileProcessingPtBr,
  pleaseWaitWhileProcessingEs,
  pleaseWaitWhileProcessingIt,
  pleaseWaitWhileProcessingZhHans,
  pleaseWaitWhileProcessingNl,
  pleaseWaitWhileProcessingTr,
} from "./please-wait-while-processing.i18n";
import {
  questionMarkWithPopoverForGatewaysDe,
  questionMarkWithPopoverForGatewaysEn,
  questionMarkWithPopoverForGatewaysPtBr,
  questionMarkWithPopoverForGatewaysEs,
  questionMarkWithPopoverForGatewaysIt,
  questionMarkWithPopoverForGatewaysZhHans,
  questionMarkWithPopoverForGatewaysNl,
  questionMarkWithPopoverForGatewaysTr,
} from "./question-mark-with-popover-for-gateways.i18n";
import {
  renderOnlyForDevelopersInfoDe,
  renderOnlyForDevelopersInfoEn,
  renderOnlyForDevelopersInfoPtBr,
  renderOnlyForDevelopersInfoEs,
  renderOnlyForDevelopersInfoIt,
  renderOnlyForDevelopersInfoZhHans,
  renderOnlyForDevelopersInfoNl,
  renderOnlyForDevelopersInfoTr,
} from "./render-only-for-developers-info.i18n";
import {
  renderUnreleasedFeaturesInfoDe,
  renderUnreleasedFeaturesInfoEn,
  renderUnreleasedFeaturesInfoPtBr,
  renderUnreleasedFeaturesInfoEs,
  renderUnreleasedFeaturesInfoIt,
  renderUnreleasedFeaturesInfoZhHans,
  renderUnreleasedFeaturesInfoNl,
  renderUnreleasedFeaturesInfoTr,
} from "./render-unreleased-features-info.i18n";
import {
  selectedItemsHiddenTextDe,
  selectedItemsHiddenTextEn,
  selectedItemsHiddenTextPtBr,
  selectedItemsHiddenTextEs,
  selectedItemsHiddenTextIt,
  selectedItemsHiddenTextZhHans,
  selectedItemsHiddenTextNl,
  selectedItemsHiddenTextTr,
} from "./selected-items-hidden.i18n";
import {
  sourceInfoDrawerModalDe,
  sourceInfoDrawerModalEn,
  sourceInfoDrawerModalPtBr,
  sourceInfoDrawerModalEs,
  sourceInfoDrawerModalIt,
  sourceInfoDrawerModalZhHans,
  sourceInfoDrawerModalNl,
  sourceInfoDrawerModalTr,
} from "./source-info-drawer-modal.i18n";
import {
  sourcesInfoWithPopoverDe,
  sourcesInfoWithPopoverEn,
  sourcesInfoWithPopoverPtBr,
  sourcesInfoWithPopoverEs,
  sourcesInfoWithPopoverIt,
  sourcesInfoWithPopoverZhHans,
  sourcesInfoWithPopoverNl,
  sourcesInfoWithPopoverTr,
} from "./sources-info-with-popover.i18n";
import {
  timeSeriesLineNoDataDe,
  timeSeriesLineNoDataEn,
  timeSeriesLineNoDataPtBr,
  timeSeriesLineNoDataEs,
  timeSeriesLineNoDataIt,
  timeSeriesLineNoDataZhHans,
  timeSeriesLineNoDataNl,
  timeSeriesLineNoDataTr,
} from "./time-series-line-no-data.i18n";
import {
  timestampsAndStringsDataTableDe,
  timestampsAndStringsDataTableEn,
  timestampsAndStringsDataTablePtBr,
  timestampsAndStringsDataTableEs,
  timestampsAndStringsDataTableIt,
  timestampsAndStringsDataTableZhHans,
  timestampsAndStringsDataTableNl,
  timestampsAndStringsDataTableTr,
} from "./timestamps-and-strings-data-table.i18n";
import {
  transferButtonDe,
  transferButtonEn,
  transferButtonPtBr,
  transferButtonEs,
  transferButtonIt,
  transferButtonZhHans,
  transferButtonNl,
  transferButtonTr,
} from "./transfer-button.i18n";
import {
  transferConfigurationToClientButtonDe,
  transferConfigurationToClientButtonEn,
  transferConfigurationToClientButtonPtBr,
  transferConfigurationToClientButtonEs,
  transferConfigurationToClientButtonIt,
  transferConfigurationToClientButtonZhHans,
  transferConfigurationToClientButtonNl,
  transferConfigurationToClientButtonTr,
} from "./transfer-configuration-to-client-button.i18n";
import {
  unitInputAndPopoverDe,
  unitInputAndPopoverEn,
  unitInputAndPopoverPtBr,
  unitInputAndPopoverEs,
  unitInputAndPopoverIt,
  unitInputAndPopoverZhHans,
  unitInputAndPopoverNl,
  unitInputAndPopoverTr,
} from "./unit-input-and-popover.i18n";
import {
  unsavedStructureModalDe,
  unsavedStructureModalEn,
  unsavedStructureModalPtBr,
  unsavedStructureModalEs,
  unsavedStructureModalIt,
  unsavedStructureModalZhHans,
  unsavedStructureModalNl,
  unsavedStructureModalTr,
} from "./unsaved-structure-modal.i18n";
import {
  versionStringInfoDe,
  versionStringInfoEn,
  versionStringInfoPtBr,
  versionStringInfoEs,
  versionStringInfoIt,
  versionStringInfoZhHans,
  versionStringInfoNl,
  versionStringInfoTr,
} from "./version-string-info.i18n";
import {
  timezoneStringInfoDe,
  timezoneStringInfoEn,
  timezoneStringInfoPtBr,
  timezoneStringInfoEs,
  timezoneStringInfoIt,
  timezoneStringInfoZhHans,
  timezoneStringInfoNl,
  timezoneStringInfoTr,
} from "./timezone-string-info.i18n";
import {
  applyAutoMatchBlueprintDe,
  applyAutoMatchBlueprintEn,
  applyAutoMatchBlueprintPtBr,
  applyAutoMatchBlueprintEs,
  applyAutoMatchBlueprintIt,
  applyAutoMatchBlueprintZhHans,
  applyAutoMatchBlueprintNl,
  applyAutoMatchBlueprintTr,
} from "./apply-auto-match-blueprint.i18n";
import {
  applyMyBlueprintLibraryDe,
  applyMyBlueprintLibraryEn,
  applyMyBlueprintLibraryPtBr,
  applyMyBlueprintLibraryEs,
  applyMyBlueprintLibraryIt,
  applyMyBlueprintLibraryZhHans,
  applyMyBlueprintLibraryNl,
  applyMyBlueprintLibraryTr,
} from "./apply-my-blueprint-library.i18n";
import {
  findAutoMatchBlueprintDe,
  findAutoMatchBlueprintEn,
  findAutoMatchBlueprintPtBr,
  findAutoMatchBlueprintEs,
  findAutoMatchBlueprintIt,
  findAutoMatchBlueprintZhHans,
  findAutoMatchBlueprintNl,
  findAutoMatchBlueprintTr,
} from "./find-auto-match-blueprint.i18n";
import {
  findMyBlueprintLibraryModalDe,
  findMyBlueprintLibraryModalEn,
  findMyBlueprintLibraryModalPtBr,
  findMyBlueprintLibraryModalEs,
  findMyBlueprintLibraryModalIt,
  findMyBlueprintLibraryModalZhHans,
  findMyBlueprintLibraryModalNl,
  findMyBlueprintLibraryModalTr,
} from "./find-my-blueprint-library.i18n";
import {
  machineStructurePanelDe,
  machineStructurePanelEn,
  machineStructurePanelPtBr,
  machineStructurePanelEs,
  machineStructurePanelIt,
  machineStructurePanelZhHans,
  machineStructurePanelNl,
  machineStructurePanelTr,
} from "./machine-structure-panel.i18n";
import {
  machineOverviewContainerDe,
  machineOverviewContainerEn,
  machineOverviewContainerPtBr,
  machineOverviewContainerEs,
  machineOverviewContainerIt,
  machineOverviewContainerZhHans,
  machineOverviewContainerNl,
  machineOverviewContainerTr,
} from "./machine-overview-container.i18n";
import {
  machineOverviewContainerDrBoyDe,
  machineOverviewContainerDrBoyEn,
  machineOverviewContainerDrBoyPtBr,
  machineOverviewContainerDrBoyEs,
  machineOverviewContainerDrBoyIt,
  machineOverviewContainerDrBoyZhHans,
  machineOverviewContainerDrBoyNl,
  machineOverviewContainerDrBoyTr,
} from "./machine-overview-container-dr-boy.i18n";
import {
  staticMachineOverviewContainerForTtDe,
  staticMachineOverviewContainerForTtEn,
  staticMachineOverviewContainerForTtPtBr,
  staticMachineOverviewContainerForTtEs,
  staticMachineOverviewContainerForTtIt,
  staticMachineOverviewContainerForTtZhHans,
  staticMachineOverviewContainerForTtNl,
  staticMachineOverviewContainerForTtTr,
} from "./static-machine-overview-container-for-tt.i18n";
import {
  machineOverviewWidgetDe,
  machineOverviewWidgetEn,
  machineOverviewWidgetPtBr,
  machineOverviewWidgetEs,
  machineOverviewWidgetIt,
  machineOverviewWidgetZhHans,
  machineOverviewWidgetTr,
  machineOverviewWidgetNl,
} from "./machine-overview-widget.i18n";
import {
  factoryDashboardPageDe,
  factoryDashboardPageEn,
  factoryDashboardPagePtBr,
  factoryDashboardPageEs,
  factoryDashboardPageIt,
  factoryDashboardPageZhHans,
  factoryDashboardPageNl,
  factoryDashboardPageTr,
} from "./factory-dashboard-page.i18n";

import {
  ourNodeDetailsPanelDe,
  ourNodeDetailsPanelEn,
  ourNodeDetailsPanelPtBr,
  ourNodeDetailsPanelEs,
  ourNodeDetailsPanelIt,
  ourNodeDetailsPanelZhHans,
  ourNodeDetailsPanelNl,
  ourNodeDetailsPanelTr,
} from "./our-node-details-panel.i18n";
import {
  noDataInTimeframeDe,
  noDataInTimeframeEn,
  noDataInTimeframePtBr,
  noDataInTimeframeEs,
  noDataInTimeframeIt,
  noDataInTimeframeZhHans,
  noDataInTimeframeNl,
  noDataInTimeframeTr,
} from "./no-data-in-timeframe.i18n";
import {
  dashboardTimeseriesInfoWithPopoverEn,
  dashboardTimeseriesInfoWithPopoverPtBr,
  dashboardTimeseriesInfoWithPopoverEs,
  dashboardTimeseriesInfoWithPopoverIt,
  dashboardTimeseriesInfoWithPopoverDe,
  dashboardTimeseriesInfoWithPopoverZhHans,
  dashboardTimeseriesInfoWithPopoverNl,
  dashboardTimeseriesInfoWithPopoverTr,
} from "./dashboard-timeseries-info-with-popover.i18n";
import {
  overwriteStructureWarningModalDe,
  overwriteStructureWarningModalEn,
  overwriteStructureWarningModalPtBr,
  overwriteStructureWarningModalEs,
  overwriteStructureWarningModalIt,
  overwriteStructureWarningModalZhHans,
  overwriteStructureWarningModalNl,
  overwriteStructureWarningModalTr,
} from "./overwrite-structure-warning-modal.i18n";
import {
  alarmListNodeDe,
  alarmListNodeEn,
  alarmListNodePtBr,
  alarmListNodeEs,
  alarmListNodeIt,
  alarmListNodeZhHans,
  alarmListNodeNl,
  alarmListNodeTr,
} from "./alarm-list-node.i18n";
import {
  filterIconDe,
  filterIconEn,
  filterIconPtBr,
  filterIconEs,
  filterIconIt,
  filterIconZhHans,
  filterIconNl,
  filterIconTr,
} from "./filter-icon.i18n";
import {
  blueprintStateInfoBannerRestructuringCounterDe,
  blueprintStateInfoBannerRestructuringCounterEn,
  blueprintStateInfoBannerRestructuringCounterPtBr,
  blueprintStateInfoBannerRestructuringCounterEs,
  blueprintStateInfoBannerRestructuringCounterIt,
  blueprintStateInfoBannerRestructuringCounterZhHans,
  blueprintStateInfoBannerRestructuringCounterNl,
  blueprintStateInfoBannerRestructuringCounterTr,
} from "./blueprint-state-info-banner-restructuring-counter.i18n";
import {
  blueprintStateInfoBannerBlueprintNameVerifiedWrapperDe,
  blueprintStateInfoBannerBlueprintNameVerifiedWrapperEn,
  blueprintStateInfoBannerBlueprintNameVerifiedWrapperPtBr,
  blueprintStateInfoBannerBlueprintNameVerifiedWrapperEs,
  blueprintStateInfoBannerBlueprintNameVerifiedWrapperIt,
  blueprintStateInfoBannerBlueprintNameVerifiedWrapperZhHans,
  blueprintStateInfoBannerBlueprintNameVerifiedWrapperNl,
  blueprintStateInfoBannerBlueprintNameVerifiedWrapperTr,
} from "./blueprint-state-info-banner-blueprint-name-verified-wrapper.i18n";
import {
  replaceBlueprintGradientBoxDescriptionContainerDe,
  replaceBlueprintGradientBoxDescriptionContainerEn,
  replaceBlueprintGradientBoxDescriptionContainerPtBr,
  replaceBlueprintGradientBoxDescriptionContainerEs,
  replaceBlueprintGradientBoxDescriptionContainerIt,
  replaceBlueprintGradientBoxDescriptionContainerZhHans,
  replaceBlueprintGradientBoxDescriptionContainerNl,
  replaceBlueprintGradientBoxDescriptionContainerTr,
} from "./replace-blueprint-gradient-box-description-container.i18n";
import {
  noGatewaysDetectedViewDe,
  noGatewaysDetectedViewEn,
  noGatewaysDetectedViewPtBr,
  noGatewaysDetectedViewEs,
  noGatewaysDetectedViewIt,
  noGatewaysDetectedViewZhHans,
  noGatewaysDetectedViewNl,
  noGatewaysDetectedViewTr,
} from "./no-gateways-detected-view.i18n";
import {
  noMachinesDetectedViewDe,
  noMachinesDetectedViewEn,
  noMachinesDetectedViewPtBr,
  noMachinesDetectedViewEs,
  noMachinesDetectedViewIt,
  noMachinesDetectedViewZhHans,
  noMachinesDetectedViewNl,
  noMachinesDetectedViewTr,
} from "./no-sources-detected-view.i18n";
import {
  unsavedStructureForNodeManagerNavigationModalDe,
  unsavedStructureForNodeManagerNavigationModalEn,
  unsavedStructureForNodeManagerNavigationModalPtBr,
  unsavedStructureForNodeManagerNavigationModalEs,
  unsavedStructureForNodeManagerNavigationModalIt,
  unsavedStructureForNodeManagerNavigationModalZhHans,
  unsavedStructureForNodeManagerNavigationModalNl,
  unsavedStructureForNodeManagerNavigationModalTr,
} from "./unsaved-structure-for-node-manager-navigation-modal.i18n";
import {
  unsavedConditionMonitoringForNodeManagerNavigationModalDe,
  unsavedConditionMonitoringForNodeManagerNavigationModalEn,
  unsavedConditionMonitoringForNodeManagerNavigationModalPtBr,
  unsavedConditionMonitoringForNodeManagerNavigationModalEs,
  unsavedConditionMonitoringForNodeManagerNavigationModalIt,
  unsavedConditionMonitoringForNodeManagerNavigationModalZhHans,
  unsavedConditionMonitoringForNodeManagerNavigationModalNl,
  unsavedConditionMonitoringForNodeManagerNavigationModalTr,
} from "./unsaved-condition-monitoring-for-node-manager-navigation-modal.i18n";
import {
  alarmProfileEmailRecipientsDrawerModalDe,
  alarmProfileEmailRecipientsDrawerModalEn,
  alarmProfileEmailRecipientsDrawerModalPtBr,
  alarmProfileEmailRecipientsDrawerModalEs,
  alarmProfileEmailRecipientsDrawerModalIt,
  alarmProfileEmailRecipientsDrawerModalZhHans,
  alarmProfileEmailRecipientsDrawerModalNl,
  alarmProfileEmailRecipientsDrawerModalTr,
} from "./alarm-profile-email-recipients-drawer-modal.i18n";
import {
  saveBlueprintModalDe,
  saveBlueprintModalEn,
  saveBlueprintModalPtBr,
  saveBlueprintModalEs,
  saveBlueprintModalIt,
  saveBlueprintModalZhHans,
  saveBlueprintModalNl,
  saveBlueprintModalTr,
} from "./save-blueprint-modal.i18n";
import {
  replaceBlueprintModalDe,
  replaceBlueprintModalEn,
  replaceBlueprintModalPtBr,
  replaceBlueprintModalEs,
  replaceBlueprintModalIt,
  replaceBlueprintModalZhHans,
  replaceBlueprintModalNl,
  replaceBlueprintModalTr,
} from "./replace-blueprint-modal.i18n";
import {
  gatewaysListRowDe,
  gatewaysListRowEn,
  gatewaysListRowPtBr,
  gatewaysListRowEs,
  gatewaysListRowIt,
  gatewaysListRowZhHans,
  gatewaysListRowNl,
  gatewaysListRowTr,
} from "./gateways-list-row.i18n";

import {
  editGatewayNameDe,
  editGatewayNameEn,
  editGatewayNamePtBr,
  editGatewayNameEs,
  editGatewayNameIt,
  editGatewayNameZhHans,
  editGatewayNameNl,
  editGatewayNameTr,
} from "./edit-gateway-name.i18n";
import {
  questionMarkWithPopoverForConditionMonitoringDe,
  questionMarkWithPopoverForConditionMonitoringEn,
  questionMarkWithPopoverForConditionMonitoringPtBr,
  questionMarkWithPopoverForConditionMonitoringEs,
  questionMarkWithPopoverForConditionMonitoringIt,
  questionMarkWithPopoverForConditionMonitoringZhHans,
  questionMarkWithPopoverForConditionMonitoringNl,
  questionMarkWithPopoverForConditionMonitoringTr,
} from "./question-mark-with-popover-for-condition-monitoring.i18n";
import {
  machineStructurePanelControlBarDe,
  machineStructurePanelControlBarEn,
  machineStructurePanelControlBarPtBr,
  machineStructurePanelControlBarEs,
  machineStructurePanelControlBarIt,
  machineStructurePanelControlBarZhHans,
  machineStructurePanelControlBarNl,
  machineStructurePanelControlBarTr,
} from "./machine-structure-panel-control-bar.i18n";
import {
  nodesCounterSelectorDe,
  nodesCounterSelectorEn,
  nodesCounterSelectorPtBr,
  nodesCounterSelectorEs,
  nodesCounterSelectorIt,
  nodesCounterSelectorZhHans,
  nodesCounterSelectorNl,
  nodesCounterSelectorTr,
} from "./nodes-counter-selector.i18n";
import {
  alarmListDe,
  alarmListEn,
  alarmListPtBr,
  alarmListEs,
  alarmListIt,
  alarmListZhHans,
  alarmListNl,
  alarmListTr,
} from "./alarm-list.i18n";
import {
  initialStructurePanelDe,
  initialStructurePanelEn,
  initialStructurePanelPtBr,
  initialStructurePanelEs,
  initialStructurePanelIt,
  initialStructurePanelZhHans,
  initialStructurePanelNl,
  initialStructurePanelTr,
} from "./initial-structure-panel.i18n";
import {
  initialStructureFilterDe,
  initialStructureFilterEn,
  initialStructureFilterPtBr,
  initialStructureFilterEs,
  initialStructureFilterIt,
  initialStructureFilterZhHans,
  initialStructureFilterNl,
  initialStructureFilterTr,
} from "./initial-structure-filter.i18n";
import {
  machineStructureFilterDe,
  machineStructureFilterEn,
  machineStructureFilterPtBr,
  machineStructureFilterEs,
  machineStructureFilterIt,
  machineStructureFilterZhHans,
  machineStructureFilterNl,
  machineStructureFilterTr,
} from "./machine-structure-filter.i18n";
import {
  questionMarkPopoverDe,
  questionMarkPopoverEn,
  questionMarkPopoverPtBr,
  questionMarkPopoverEs,
  questionMarkPopoverIt,
  questionMarkPopoverZhHans,
  questionMarkPopoverNl,
  questionMarkPopoverTr,
} from "./question-mark-popover.i18n";
import {
  bigBlueprintBannerDe,
  bigBlueprintBannerEn,
  bigBlueprintBannerPtBr,
  bigBlueprintBannerEs,
  bigBlueprintBannerIt,
  bigBlueprintBannerZhHans,
  bigBlueprintBannerNl,
  bigBlueprintBannerTr,
} from "./big-blueprint-banner.i18n";
import {
  bigBlueprintBannerAutoMatchDe,
  bigBlueprintBannerAutoMatchEn,
  bigBlueprintBannerAutoMatchPtBr,
  bigBlueprintBannerAutoMatchEs,
  bigBlueprintBannerAutoMatchIt,
  bigBlueprintBannerAutoMatchZhHans,
  bigBlueprintBannerAutoMatchNl,
  bigBlueprintBannerAutoMatchTr,
} from "./big-blueprint-banner-auto-match.i18n";
import {
  smallBlueprintBannerAutoMatchDe,
  smallBlueprintBannerAutoMatchEn,
  smallBlueprintBannerAutoMatchPtBr,
  smallBlueprintBannerAutoMatchEs,
  smallBlueprintBannerAutoMatchIt,
  smallBlueprintBannerAutoMatchZhHans,
  smallBlueprintBannerAutoMatchNl,
  smallBlueprintBannerAutoMatchTr,
} from "./small-blueprint-banner-auto-match.i18n";
import {
  blueprintsTableDe,
  blueprintsTableEn,
  blueprintsTablePtBr,
  blueprintsTableEs,
  blueprintsTableIt,
  blueprintsTableZhHans,
  blueprintsTableNl,
  blueprintsTableTr,
} from "./blueprints-table.i18n";
import {
  ourNodeAncestorsLineageTreeDe,
  ourNodeAncestorsLineageTreeEn,
  ourNodeAncestorsLineageTreePtBr,
  ourNodeAncestorsLineageTreeEs,
  ourNodeAncestorsLineageTreeIt,
  ourNodeAncestorsLineageTreeZhHans,
  ourNodeAncestorsLineageTreeNl,
  ourNodeAncestorsLineageTreeTr,
} from "./our-node-ancestors-lineage-tree.i18n";
import {
  bulkEditDataAcquisitionModalDe,
  bulkEditDataAcquisitionModalEn,
  bulkEditDataAcquisitionModalPtBr,
  bulkEditDataAcquisitionModalEs,
  bulkEditDataAcquisitionModalIt,
  bulkEditDataAcquisitionModalZhHans,
  bulkEditDataAcquisitionModalNl,
  bulkEditDataAcquisitionModalTr,
} from "./bulk-edit-data-acquisition-modal.i18n";
import {
  scanInterruptionModalDe,
  scanInterruptionModalEn,
  scanInterruptionModalPtBr,
  scanInterruptionModalEs,
  scanInterruptionModalIt,
  scanInterruptionModalZhHans,
  scanInterruptionModalNl,
  scanInterruptionModalTr,
} from "./scan-interruption-modal.i18n";
import {
  snackbarNotificationsDe,
  snackbarNotificationsEn,
  snackbarNotificationsPtBr,
  snackbarNotificationsEs,
  snackbarNotificationsIt,
  snackbarNotificationsZhHans,
  snackbarNotificationsNl,
  snackbarNotificationsTr,
} from "./snackbar-notifications.i18n";
import {
  alarmProfilePopoverDe,
  alarmProfilePopoverEn,
  alarmProfilePopoverPtBr,
  alarmProfilePopoverEs,
  alarmProfilePopoverIt,
  alarmProfilePopoverZhHans,
  alarmProfilePopoverNl,
  alarmProfilePopoverTr,
} from "./alarm-profile-popover.i18n";
import {
  alarmProfileCardDe,
  alarmProfileCardEn,
  alarmProfileCardPtBr,
  alarmProfileCardEs,
  alarmProfileCardIt,
  alarmProfileCardZhHans,
  alarmProfileCardNl,
  alarmProfileCardTr,
} from "./alarm-profile-card.i18n";
import {
  drawerIconContainerDe,
  drawerIconContainerEn,
  drawerIconContainerPtBr,
  drawerIconContainerEs,
  drawerIconContainerIt,
  drawerIconContainerZhHans,
  drawerIconContainerNl,
  drawerIconContainerTr,
} from "./drawer-icon-container.i18n";
import {
  filteredMissingNodesPillButtonDe,
  filteredMissingNodesPillButtonEn,
  filteredMissingNodesPillButtonPtBr,
  filteredMissingNodesPillButtonEs,
  filteredMissingNodesPillButtonIt,
  filteredMissingNodesPillButtonZhHans,
  filteredMissingNodesPillButtonNl,
  filteredMissingNodesPillButtonTr,
} from "./filtered-missing-nodes-pill-button.i18n";
import {
  foundAllNodesPillBoxDe,
  foundAllNodesPillBoxEn,
  foundAllNodesPillBoxPtBr,
  foundAllNodesPillBoxEs,
  foundAllNodesPillBoxIt,
  foundAllNodesPillBoxZhHans,
  foundAllNodesPillBoxNl,
  foundAllNodesPillBoxTr,
} from "./found-all-nodes-pill-box.i18n";
import {
  resolvedAllNodesPillButtonDe,
  resolvedAllNodesPillButtonEn,
  resolvedAllNodesPillButtonPtBr,
  resolvedAllNodesPillButtonEs,
  resolvedAllNodesPillButtonIt,
  resolvedAllNodesPillButtonZhHans,
  resolvedAllNodesPillButtonNl,
  resolvedAllNodesPillButtonTr,
} from "./resolved-all-nodes-pill-button.i18n";
import {
  unfilteredMissingNodesPillButtonDe,
  unfilteredMissingNodesPillButtonEn,
  unfilteredMissingNodesPillButtonPtBr,
  unfilteredMissingNodesPillButtonEs,
  unfilteredMissingNodesPillButtonIt,
  unfilteredMissingNodesPillButtonZhHans,
  unfilteredMissingNodesPillButtonNl,
  unfilteredMissingNodesPillButtonTr,
} from "./unfiltered-missing-nodes-pill-button.i18n";
import {
  alarmProfileEmailRecipientsListDe,
  alarmProfileEmailRecipientsListEn,
  alarmProfileEmailRecipientsListPtBr,
  alarmProfileEmailRecipientsListEs,
  alarmProfileEmailRecipientsListIt,
  alarmProfileEmailRecipientsListZhHans,
  alarmProfileEmailRecipientsListNl,
  alarmProfileEmailRecipientsListTr,
} from "./alarm-profile-email-recipients-list.i18n";
import {
  blueprintStateInfoBannerAuthorDateWrapperDe,
  blueprintStateInfoBannerAuthorDateWrapperEn,
  blueprintStateInfoBannerAuthorDateWrapperPtBr,
  blueprintStateInfoBannerAuthorDateWrapperEs,
  blueprintStateInfoBannerAuthorDateWrapperIt,
  blueprintStateInfoBannerAuthorDateWrapperZhHans,
  blueprintStateInfoBannerAuthorDateWrapperNl,
  blueprintStateInfoBannerAuthorDateWrapperTr,
} from "./blueprint-state-info-banner-author-date-wrapper.i18n";
import {
  blueprintStateInfoBannerDataAcquisitionSummaryWrapperDe,
  blueprintStateInfoBannerDataAcquisitionSummaryWrapperEn,
  blueprintStateInfoBannerDataAcquisitionSummaryWrapperPtBr,
  blueprintStateInfoBannerDataAcquisitionSummaryWrapperEs,
  blueprintStateInfoBannerDataAcquisitionSummaryWrapperIt,
  blueprintStateInfoBannerDataAcquisitionSummaryWrapperZhHans,
  blueprintStateInfoBannerDataAcquisitionSummaryWrapperNl,
  blueprintStateInfoBannerDataAcquisitionSummaryWrapperTr,
} from "./blueprint-state-info-banner-data-acquisition-summary-wrapper.i18n";
import {
  blueprintTableBodyFlexWrapperWithVerifiedIconDe,
  blueprintTableBodyFlexWrapperWithVerifiedIconEn,
  blueprintTableBodyFlexWrapperWithVerifiedIconPtBr,
  blueprintTableBodyFlexWrapperWithVerifiedIconEs,
  blueprintTableBodyFlexWrapperWithVerifiedIconIt,
  blueprintTableBodyFlexWrapperWithVerifiedIconZhHans,
  blueprintTableBodyFlexWrapperWithVerifiedIconNl,
  blueprintTableBodyFlexWrapperWithVerifiedIconTr,
} from "./blueprint-table-body-flex-wrapper-with-verified-icon.i18n";
import {
  blueprintUnassignedWarningIgnoreButtonWrapperDe,
  blueprintUnassignedWarningIgnoreButtonWrapperEn,
  blueprintUnassignedWarningIgnoreButtonWrapperPtBr,
  blueprintUnassignedWarningIgnoreButtonWrapperEs,
  blueprintUnassignedWarningIgnoreButtonWrapperIt,
  blueprintUnassignedWarningIgnoreButtonWrapperZhHans,
  blueprintUnassignedWarningIgnoreButtonWrapperNl,
  blueprintUnassignedWarningIgnoreButtonWrapperTr,
} from "./blueprint-unassigned-warning-ignore-button-wrapper.i18n";
import {
  replaceBlueprintGradientBoxInfoContainerDe,
  replaceBlueprintGradientBoxInfoContainerEn,
  replaceBlueprintGradientBoxInfoContainerPtBr,
  replaceBlueprintGradientBoxInfoContainerEs,
  replaceBlueprintGradientBoxInfoContainerIt,
  replaceBlueprintGradientBoxInfoContainerZhHans,
  replaceBlueprintGradientBoxInfoContainerNl,
  replaceBlueprintGradientBoxInfoContainerTr,
} from "./replace-blueprint-gradient-box-info-container.i18n";
import {
  unassignedFilterViewTitleIgnoreAllButtonWrapperDe,
  unassignedFilterViewTitleIgnoreAllButtonWrapperEn,
  unassignedFilterViewTitleIgnoreAllButtonWrapperPtBr,
  unassignedFilterViewTitleIgnoreAllButtonWrapperEs,
  unassignedFilterViewTitleIgnoreAllButtonWrapperIt,
  unassignedFilterViewTitleIgnoreAllButtonWrapperZhHans,
  unassignedFilterViewTitleIgnoreAllButtonWrapperNl,
  unassignedFilterViewTitleIgnoreAllButtonWrapperTr,
} from "./unassigned-filter-view-title-ignore-all-button-wrapper.i18n";
import {
  blueprintStateInfoBannerRestructuringSummaryWrapperDe,
  blueprintStateInfoBannerRestructuringSummaryWrapperEn,
  blueprintStateInfoBannerRestructuringSummaryWrapperPtBr,
  blueprintStateInfoBannerRestructuringSummaryWrapperEs,
  blueprintStateInfoBannerRestructuringSummaryWrapperIt,
  blueprintStateInfoBannerRestructuringSummaryWrapperZhHans,
  blueprintStateInfoBannerRestructuringSummaryWrapperNl,
  blueprintStateInfoBannerRestructuringSummaryWrapperTr,
} from "./blueprint-state-info-banner-restructuring-summary-wrapper.i18n";
import {
  renderRestructuringSummaryNodesPillElementDe,
  renderRestructuringSummaryNodesPillElementEn,
  renderRestructuringSummaryNodesPillElementPtBr,
  renderRestructuringSummaryNodesPillElementEs,
  renderRestructuringSummaryNodesPillElementIt,
  renderRestructuringSummaryNodesPillElementZhHans,
  renderRestructuringSummaryNodesPillElementNl,
  renderRestructuringSummaryNodesPillElementTr,
} from "./render-restructuring-summary-nodes-pill-element.i18n";
import {
  connectedGatewaysListContainerDe,
  connectedGatewaysListContainerEn,
  connectedGatewaysListContainerPtBr,
  connectedGatewaysListContainerEs,
  connectedGatewaysListContainerIt,
  connectedGatewaysListContainerZhHans,
  connectedGatewaysListContainerNl,
  connectedGatewaysListContainerTr,
} from "./connected-gateways-list-container.i18n";
import {
  drawerModalDe,
  drawerModalEn,
  drawerModalPtBr,
  drawerModalEs,
  drawerModalIt,
  drawerModalZhHans,
  drawerModalNl,
  drawerModalTr,
} from "./drawer-modal.i18n";
import {
  tileDrawerModalDe,
  tileDrawerModalEn,
  tileDrawerModalPtBr,
  tileDrawerModalEs,
  tileDrawerModalIt,
  tileDrawerModalZhHans,
  tileDrawerModalNl,
  tileDrawerModalTr,
} from "./tile-drawer-modal.i18n";
import {
  tileDe,
  tileEn,
  tilePtBr,
  tileEs,
  tileIt,
  tileZhHans,
  tileNl,
  tileTr,
} from "./tile.i18n";
import {
  tileFormDe,
  tileFormEn,
  tileFormPtBr,
  tileFormEs,
  tileFormIt,
  tileFormZhHans,
  tileFormNl,
  tileFormTr,
} from "./tile-form.i18n";
import {
  tsidContainerDe,
  tsidContainerEn,
  tsidContainerPtBr,
  tsidContainerEs,
  tsidContainerIt,
  tsidContainerZhHans,
  tsidContainerNl,
  tsidContainerTr,
} from "./tsid-container.i18n";
import {
  replaceBlueprintGradientBoxDe,
  replaceBlueprintGradientBoxEn,
  replaceBlueprintGradientBoxPtBr,
  replaceBlueprintGradientBoxEs,
  replaceBlueprintGradientBoxIt,
  replaceBlueprintGradientBoxZhHans,
  replaceBlueprintGradientBoxNl,
  replaceBlueprintGradientBoxTr,
} from "./replace-blueprint-gradient-box.i18n";
import {
  treeViewNoOurNodeMachineStructureDragAndDropDe,
  treeViewNoOurNodeMachineStructureDragAndDropEn,
  treeViewNoOurNodeMachineStructureDragAndDropPtBr,
  treeViewNoOurNodeMachineStructureDragAndDropEs,
  treeViewNoOurNodeMachineStructureDragAndDropIt,
  treeViewNoOurNodeMachineStructureDragAndDropZhHans,
  treeViewNoOurNodeMachineStructureDragAndDropNl,
  treeViewNoOurNodeMachineStructureDragAndDropTr,
} from "./tree-view-no-our-node-machine-structure-drag-and-drop.i18n";
import {
  blueprintDescriptionPopoverDe,
  blueprintDescriptionPopoverEn,
  blueprintDescriptionPopoverPtBr,
  blueprintDescriptionPopoverEs,
  blueprintDescriptionPopoverIt,
  blueprintDescriptionPopoverZhHans,
  blueprintDescriptionPopoverNl,
  blueprintDescriptionPopoverTr,
} from "./blueprint-description-popover.i18n";
import {
  backIconButtonWithTextDe,
  backIconButtonWithTextEn,
  backIconButtonWithTextPtBr,
  backIconButtonWithTextEs,
  backIconButtonWithTextIt,
  backIconButtonWithTextZhHans,
  backIconButtonWithTextNl,
  backIconButtonWithTextTr,
} from "./back-icon-button-with-text.i18n";
import {
  buttonWithIconDe,
  buttonWithIconEn,
  buttonWithIconPtBr,
  buttonWithIconEs,
  buttonWithIconIt,
  buttonWithIconZhHans,
  buttonWithIconNl,
  buttonWithIconTr,
} from "./button-with-icon.i18n";
import {
  editWidgetDrawerModalDe,
  editWidgetDrawerModalEn,
  editWidgetDrawerModalPtBr,
  editWidgetDrawerModalEs,
  editWidgetDrawerModalIt,
  editWidgetDrawerModalNl,
  editWidgetDrawerModalZhHans,
  editWidgetDrawerModalTr,
} from "./edit-widget-drawer-modal.i18n";
import {
  multipleTextValuesDe,
  multipleTextValuesEn,
  multipleTextValuesPtBr,
  multipleTextValuesEs,
  multipleTextValuesIt,
  multipleTextValuesNl,
  multipleTextValuesZhHans,
  multipleTextValuesTr,
} from "./multiple-text-values.i18n";
import {
  counterNumberDe,
  counterNumberEn,
  counterNumberPtBr,
  counterNumberEs,
  counterNumberIt,
  counterNumberNl,
  counterNumberZhHans,
  counterNumberTr,
} from "./counter-number.i18n";
import {
  trendLineDe,
  trendLineEn,
  trendLinePtBr,
  trendLineEs,
  trendLineIt,
  trendLineNl,
  trendLineZhHans,
  trendLineTr,
} from "./trend-line.i18n";
import {
  multiLineDe,
  multiLineEn,
  multiLinePtBr,
  multiLineEs,
  multiLineIt,
  multiLineNl,
  multiLineZhHans,
  multiLineTr,
} from "./multi-line.i18n";
import {
  staticHeaderDe,
  staticHeaderEn,
  staticHeaderPtBr,
  staticHeaderEs,
  staticHeaderIt,
  staticHeaderNl,
  staticHeaderZhHans,
  staticHeaderTr,
} from "./static-header.i18n";
import {
  staticTextDe,
  staticTextEn,
  staticTextPtBr,
  staticTextEs,
  staticTextIt,
  staticTextNl,
  staticTextZhHans,
  staticTextTr,
} from "./static-text.i18n";
import {
  staticLinkDe,
  staticLinkEn,
  staticLinkPtBr,
  staticLinkEs,
  staticLinkIt,
  staticLinkNl,
  staticLinkZhHans,
  staticLinkTr,
} from "./static-link.i18n";
import {
  staticSeparatorDe,
  staticSeparatorEn,
  staticSeparatorPtBr,
  staticSeparatorEs,
  staticSeparatorIt,
  staticSeparatorNl,
  staticSeparatorZhHans,
  staticSeparatorTr,
} from "./static-separator.i18n";
import {
  machineOverviewDe,
  machineOverviewEn,
  machineOverviewPtBr,
  machineOverviewEs,
  machineOverviewIt,
  machineOverviewNl,
  machineOverviewZhHans,
  machineOverviewTr,
} from "./machine-overview.i18n";
import {
  shotDataLineChartDe,
  shotDataLineChartEn,
  shotDataLineChartPtBr,
  shotDataLineChartEs,
  shotDataLineChartIt,
  shotDataLineChartNl,
  shotDataLineChartZhHans,
  shotDataLineChartTr,
} from "./shot-data-line-chart.i18n";
import {
  singleTextValueDe,
  singleTextValueEn,
  singleTextValuePtBr,
  singleTextValueEs,
  singleTextValueIt,
  singleTextValueNl,
  singleTextValueZhHans,
  singleTextValueTr,
} from "./single-text-value.i18n";
import {
  lookbackAndPollingFieldsDe,
  lookbackAndPollingFieldsEn,
  lookbackAndPollingFieldsPtBr,
  lookbackAndPollingFieldsEs,
  lookbackAndPollingFieldsIt,
  lookbackAndPollingFieldsNl,
  lookbackAndPollingFieldsZhHans,
  lookbackAndPollingFieldsTr,
} from "./lookback-and-polling-fields.i18n";
import {
  scaleInputDe,
  scaleInputEn,
  scaleInputPtBr,
  scaleInputEs,
  scaleInputIt,
  scaleInputNl,
  scaleInputZhHans,
  scaleInputTr,
} from "./scale-input.i18n";
import {
  iconButtonWithTextDe,
  iconButtonWithTextEn,
  iconButtonWithTextPtBr,
  iconButtonWithTextEs,
  iconButtonWithTextIt,
  iconButtonWithTextZhHans,
  iconButtonWithTextNl,
  iconButtonWithTextTr,
} from "./icon-button-with-text.i18n";
import {
  dragImageDe,
  dragImageEn,
  dragImagePtBr,
  dragImageEs,
  dragImageIt,
  dragImageZhHans,
  dragImageNl,
  dragImageTr,
} from "./drag-image.i18n";
import {
  dropAreaDe,
  dropAreaEn,
  dropAreaPtBr,
  dropAreaEs,
  dropAreaIt,
  dropAreaZhHans,
  dropAreaNl,
  dropAreaTr,
} from "./drop-area.i18n";
import {
  indicatorTextDe,
  indicatorTextEn,
  indicatorTextPtBr,
  indicatorTextEs,
  indicatorTextIt,
  indicatorTextZhHans,
  indicatorTextNl,
  indicatorTextTr,
} from "./indicator-text.i18n";
import {
  infoIconAndTextDe,
  infoIconAndTextEn,
  infoIconAndTextPtBr,
  infoIconAndTextEs,
  infoIconAndTextIt,
  infoIconAndTextZhHans,
  infoIconAndTextNl,
  infoIconAndTextTr,
} from "./info-icon-and-text.i18n";
import {
  autoGenerateCertificateSettingDe,
  autoGenerateCertificateSettingEn,
  autoGenerateCertificateSettingPtBr,
  autoGenerateCertificateSettingEs,
  autoGenerateCertificateSettingIt,
  autoGenerateCertificateSettingZhHans,
  autoGenerateCertificateSettingNl,
  autoGenerateCertificateSettingTr,
} from "./auto-generate-certificate-setting.i18n";
import {
  checkedUnorderedListDe,
  checkedUnorderedListEn,
  checkedUnorderedListPtBr,
  checkedUnorderedListEs,
  checkedUnorderedListIt,
  checkedUnorderedListZhHans,
  checkedUnorderedListNl,
  checkedUnorderedListTr,
} from "./checked-unordered-list.i18n";
import {
  timeIntervalInputAndDropDownWrapperDe,
  timeIntervalInputAndDropDownWrapperEn,
  timeIntervalInputAndDropDownWrapperPtBr,
  timeIntervalInputAndDropDownWrapperEs,
  timeIntervalInputAndDropDownWrapperIt,
  timeIntervalInputAndDropDownWrapperZhHans,
  timeIntervalInputAndDropDownWrapperNl,
  timeIntervalInputAndDropDownWrapperTr,
} from "./time-interval-input-and-dropdown-wrapper.i18n";
import {
  dashboardGraphPanelContentDe,
  dashboardGraphPanelContentEn,
  dashboardGraphPanelContentPtBr,
  dashboardGraphPanelContentEs,
  dashboardGraphPanelContentIt,
  dashboardGraphPanelContentZhHans,
  dashboardGraphPanelContentNl,
  dashboardGraphPanelContentTr,
} from "./dashboard-graph-panel-content.i18n";
import {
  errorPaneDe,
  errorPaneEn,
  errorPanePtBr,
  errorPaneEs,
  errorPaneIt,
  errorPaneZhHans,
  errorPaneNl,
  errorPaneTr,
} from "./error-pane.i18n";
import {
  timeSeriesDataTypeDe,
  timeSeriesDataTypeEn,
  timeSeriesDataTypePtBr,
  timeSeriesDataTypeEs,
  timeSeriesDataTypeIt,
  timeSeriesDataTypeZhHans,
  timeSeriesDataTypeNl,
  timeSeriesDataTypeTr,
} from "./time-series-data-type.i18n";
import {
  oneShotDe,
  oneShotEn,
  oneShotPtBr,
  oneShotEs,
  oneShotIt,
  oneShotZhHans,
  oneShotNl,
  oneShotTr,
} from "./one-shot.i18n";
import {
  shotTableDe,
  shotTableEn,
  shotTablePtBr,
  shotTableEs,
  shotTableIt,
  shotTableZhHans,
  shotTableNl,
  shotTableTr,
} from "./shot-table.i18n";
import {
  nameInputOurNodeDe,
  nameInputOurNodeEn,
  nameInputOurNodePtBr,
  nameInputOurNodeEs,
  nameInputOurNodeIt,
  nameInputOurNodeZhHans,
  nameInputOurNodeNl,
  nameInputOurNodeTr,
} from "./name-input-our-node.i18n";
import {
  zendeskContactUrlDe,
  zendeskContactUrlEn,
  zendeskContactUrlPtBr,
  zendeskContactUrlEs,
  zendeskContactUrlIt,
  zendeskContactUrlZhHans,
  zendeskContactUrlNl,
  zendeskContactUrlTr,
} from "./zendesk-contact-url.i18n";
import {
  dropDownLanguageDe,
  dropDownLanguageEn,
  dropDownLanguagePtBr,
  dropDownLanguageEs,
  dropDownLanguageIt,
  dropDownLanguageZhHans,
  dropDownLanguageNl,
  dropDownLanguageTr,
} from "./dropdown-language.i18n";
import {
  iconButtonDe,
  iconButtonEn,
  iconButtonPtBr,
  iconButtonEs,
  iconButtonIt,
  iconButtonZhHans,
  iconButtonNl,
  iconButtonTr,
} from "./icon-button.i18n";
import {
  userManagementListPillsNavDe,
  userManagementListPillsNavEn,
  userManagementListPillsNavPtBr,
  userManagementListPillsNavEs,
  userManagementListPillsNavIt,
  userManagementListPillsNavZhHans,
  userManagementListPillsNavNl,
  userManagementListPillsNavTr,
} from "./user-management-list-pills-nav.i18n";
import {
  usersListViewDe,
  usersListViewEn,
  usersListViewPtBr,
  usersListViewEs,
  usersListViewIt,
  usersListViewZhHans,
  usersListViewNl,
  usersListViewTr,
} from "./users-list-view.i18n";
import {
  serviceUsersListViewDe,
  serviceUsersListViewEn,
  serviceUsersListViewPtBr,
  serviceUsersListViewEs,
  serviceUsersListViewIt,
  serviceUsersListViewZhHans,
  serviceUsersListViewNl,
  serviceUsersListViewTr,
} from "./machines-list-translations/service-users-list-view.i18n";
import {
  gatewayServiceUsersListViewDe,
  gatewayServiceUsersListViewEn,
  gatewayServiceUsersListViewPtBr,
  gatewayServiceUsersListViewEs,
  gatewayServiceUsersListViewIt,
  gatewayServiceUsersListViewZhHans,
  gatewayServiceUsersListViewNl,
  gatewayServiceUsersListViewTr,
} from "./gateway-service-users-list-view.i18n";
import {
  usersListDe,
  usersListEn,
  usersListPtBr,
  usersListEs,
  usersListIt,
  usersListZhHans,
  usersListNl,
  usersListTr,
} from "./users-list.i18n";
import {
  serviceUsersListDe,
  serviceUsersListEn,
  serviceUsersListPtBr,
  serviceUsersListEs,
  serviceUsersListIt,
  serviceUsersListZhHans,
  serviceUsersListNl,
  serviceUsersListTr,
} from "./service-users-list";
import {
  addUserDrawerModalDe,
  addUserDrawerModalEn,
  addUserDrawerModalPtBr,
  addUserDrawerModalEs,
  addUserDrawerModalIt,
  addUserDrawerModalZhHans,
  addUserDrawerModalNl,
  addUserDrawerModalTr,
} from "./add-user-drawer-modal.i18n";
import {
  userCredentialsModalDe,
  userCredentialsModalEn,
  userCredentialsModalPtBr,
  userCredentialsModalEs,
  userCredentialsModalIt,
  userCredentialsModalZhHans,
  userCredentialsModalNl,
  userCredentialsModalTr,
} from "./user-credentials-modal.i18n";
import {
  rolesSelectorDe,
  rolesSelectorEn,
  rolesSelectorPtBr,
  rolesSelectorEs,
  rolesSelectorIt,
  rolesSelectorZhHans,
  rolesSelectorNl,
  rolesSelectorTr,
} from "./roles-selector.i18n";
import {
  languageSelectorWithSearchDe,
  languageSelectorWithSearchEn,
  languageSelectorWithSearchPtBr,
  languageSelectorWithSearchEs,
  languageSelectorWithSearchIt,
  languageSelectorWithSearchZhHans,
  languageSelectorWithSearchNl,
  languageSelectorWithSearchTr,
} from "./language-selector-with-search.i18n";
import {
  timezoneDateDe,
  timezoneDateEn,
  timezoneDatePtBr,
  timezoneDateEs,
  timezoneDateIt,
  timezoneDateZhHans,
  timezoneDateNl,
  timezoneDateTr,
} from "./timezone-date.i18n";
import {
  timezoneSelectorWithSearchDe,
  timezoneSelectorWithSearchEn,
  timezoneSelectorWithSearchPtBr,
  timezoneSelectorWithSearchEs,
  timezoneSelectorWithSearchIt,
  timezoneSelectorWithSearchZhHans,
  timezoneSelectorWithSearchNl,
  timezoneSelectorWithSearchTr,
} from "./timezone-selector-with-search.i18n";
import {
  validateUserDrawerInputsUtilDe,
  validateUserDrawerInputsUtilEn,
  validateUserDrawerInputsUtilPtBr,
  validateUserDrawerInputsUtilEs,
  validateUserDrawerInputsUtilIt,
  validateUserDrawerInputsUtilZhHans,
  validateUserDrawerInputsUtilNl,
  validateUserDrawerInputsUtilTr,
} from "./validate-user-drawer-inputs-util.i18n";
import {
  editUserDrawerModalDe,
  editUserDrawerModalEn,
  editUserDrawerModalPtBr,
  editUserDrawerModalEs,
  editUserDrawerModalIt,
  editUserDrawerModalZhHans,
  editUserDrawerModalNl,
  editUserDrawerModalTr,
} from "./edit-user-drawer-modal.i18n";
import {
  twoFactorAuthenticationButtonsWrapperDe,
  twoFactorAuthenticationButtonsWrapperEn,
  twoFactorAuthenticationButtonsWrapperPtBr,
  twoFactorAuthenticationButtonsWrapperEs,
  twoFactorAuthenticationButtonsWrapperIt,
  twoFactorAuthenticationButtonsWrapperZhHans,
  twoFactorAuthenticationButtonsWrapperNl,
  twoFactorAuthenticationButtonsWrapperTr,
} from "./two-factor-authentication-buttons-wrapper.i18n";
import {
  userStatusWithSwitchDe,
  userStatusWithSwitchEn,
  userStatusWithSwitchPtBr,
  userStatusWithSwitchEs,
  userStatusWithSwitchIt,
  userStatusWithSwitchZhHans,
  userStatusWithSwitchNl,
  userStatusWithSwitchTr,
} from "./user-status-with-switch.i18n";
import {
  editServiceUserDrawerModalDe,
  editServiceUserDrawerModalEn,
  editServiceUserDrawerModalPtBr,
  editServiceUserDrawerModalEs,
  editServiceUserDrawerModalIt,
  editServiceUserDrawerModalZhHans,
  editServiceUserDrawerModalNl,
  editServiceUserDrawerModalTr,
} from "./edit-service-user-drawer-modal.i18n";
import {
  addServiceUserDrawerModalDe,
  addServiceUserDrawerModalEn,
  addServiceUserDrawerModalPtBr,
  addServiceUserDrawerModalEs,
  addServiceUserDrawerModalIt,
  addServiceUserDrawerModalZhHans,
  addServiceUserDrawerModalNl,
  addServiceUserDrawerModalTr,
} from "./add-service-user-drawer-modal.i18n";
import {
  machinesRequestRemoteMachineAccessDrawerModalDe,
  machinesRequestRemoteMachineAccessDrawerModalEn,
  machinesRequestRemoteMachineAccessDrawerModalPtBr,
  machinesRequestRemoteMachineAccessDrawerModalEs,
  machinesRequestRemoteMachineAccessDrawerModalIt,
  machinesRequestRemoteMachineAccessDrawerModalZhHans,
  machinesRequestRemoteMachineAccessDrawerModalNl,
  machinesRequestRemoteMachineAccessDrawerModalTr,
} from "./machines-list-translations/machines-request-remote-machine-access-drawer-modal.i18n";
import {
  machinesCancelRequestDisconnectSupportModalDe,
  machinesCancelRequestDisconnectSupportModalEn,
  machinesCancelRequestDisconnectSupportModalPtBr,
  machinesCancelRequestDisconnectSupportModalEs,
  machinesCancelRequestDisconnectSupportModalIt,
  machinesCancelRequestDisconnectSupportModalZhHans,
  machinesCancelRequestDisconnectSupportModalNl,
  machinesCancelRequestDisconnectSupportModalTr,
} from "./machines-list-translations/machines-cancel-request-disconnect-support-modal.i18n";
import {
  machinesRemoteSupportActiveButtonDe,
  machinesRemoteSupportActiveButtonEn,
  machinesRemoteSupportActiveButtonPtBr,
  machinesRemoteSupportActiveButtonEs,
  machinesRemoteSupportActiveButtonIt,
  machinesRemoteSupportActiveButtonZhHans,
  machinesRemoteSupportActiveButtonNl,
  machinesRemoteSupportActiveButtonTr,
} from "./machines-list-translations/machines-remote-support-active-button.i18n";
import {
  machinesCancelRequestCrossModalDe,
  machinesCancelRequestCrossModalEn,
  machinesCancelRequestCrossModalPtBr,
  machinesCancelRequestCrossModalEs,
  machinesCancelRequestCrossModalIt,
  machinesCancelRequestCrossModalZhHans,
  machinesCancelRequestCrossModalNl,
  machinesCancelRequestCrossModalTr,
} from "./machines-list-translations/machines-cancel-request-cross-modal.i18n";
import {
  vncCountdownBarDe,
  vncCountdownBarEn,
  vncCountdownBarPtBr,
  vncCountdownBarEs,
  vncCountdownBarIt,
  vncCountdownBarZhHans,
  vncCountdownBarNl,
  vncCountdownBarTr,
} from "./vnc-countdown-bar.i18n";
import {
  vpnManagerByRolePageDe,
  vpnManagerByRolePageEn,
  vpnManagerByRolePagePtBr,
  vpnManagerByRolePageEs,
  vpnManagerByRolePageIt,
  vpnManagerByRolePageZhHans,
  vpnManagerByRolePageNl,
  vpnManagerByRolePageTr,
} from "./machines-list-translations/machines-list-page.i18n";
import {
  machinesListDe,
  machinesListEn,
  machinesListPtBr,
  machinesListEs,
  machinesListIt,
  machinesListZhHans,
  machinesListNl,
  machinesListTr,
} from "./machines-list-translations/machines-list.i18n";
import {
  machinesListHeaderExpandCollapseAllDe,
  machinesListHeaderExpandCollapseAllEn,
  machinesListHeaderExpandCollapseAllPtBr,
  machinesListHeaderExpandCollapseAllEs,
  machinesListHeaderExpandCollapseAllIt,
  machinesListHeaderExpandCollapseAllZhHans,
  machinesListHeaderExpandCollapseAllNl,
  machinesListHeaderExpandCollapseAllTr,
} from "./machines-list-translations/machines-list-header-expand-collapse-all.i18n";
import {
  machinesListRowEn,
  machinesListRowPtBr,
  machinesListRowEs,
  machinesListRowIt,
  machinesListRowDe,
  machinesListRowZhHans,
  machinesListRowNl,
  machinesListRowTr,
} from "./machines-list-translations/machines-list-row.i18n";
import {
  machinesRemoteSupportRequestedButtonDe,
  machinesRemoteSupportRequestedButtonEn,
  machinesRemoteSupportRequestedButtonPtBr,
  machinesRemoteSupportRequestedButtonEs,
  machinesRemoteSupportRequestedButtonIt,
  machinesRemoteSupportRequestedButtonZhHans,
  machinesRemoteSupportRequestedButtonNl,
  machinesRemoteSupportRequestedButtonTr,
} from "./machines-list-translations/machines-remote-support-requested-button.i18n";
import {
  machinesListWithCompaniesDe,
  machinesListWithCompaniesEn,
  machinesListWithCompaniesPtBr,
  machinesListWithCompaniesEs,
  machinesListWithCompaniesIt,
  machinesListWithCompaniesZhHans,
  machinesListWithCompaniesNl,
  machinesListWithCompaniesTr,
} from "./machines-list-translations/machines-list-with-companies.i18n";
import {
  gatewayMachinesListHeaderDe,
  gatewayMachinesListHeaderEn,
  gatewayMachinesListHeaderPtBr,
  gatewayMachinesListHeaderEs,
  gatewayMachinesListHeaderIt,
  gatewayMachinesListHeaderZhHans,
  gatewayMachinesListHeaderNl,
  gatewayMachinesListHeaderTr,
} from "./gateway-machines-list-header.i18n";
import {
  gatewayMachineListRowDe,
  gatewayMachineListRowEn,
  gatewayMachineListRowPtBr,
  gatewayMachineListRowEs,
  gatewayMachineListRowIt,
  gatewayMachineListRowZhHans,
  gatewayMachineListRowNl,
  gatewayMachineListRowTr,
} from "./gateway-machine-list-row.i18n";
import {
  editSourceNameDe,
  editSourceNameEn,
  editSourceNamePtBr,
  editSourceNameEs,
  editSourceNameIt,
  editSourceNameZhHans,
  editSourceNameNl,
  editSourceNameTr,
} from "./edit-source-name-sources-list.i18n";
import {
  rolesDescriptionsPopoverDe,
  rolesDescriptionsPopoverEn,
  rolesDescriptionsPopoverPtBr,
  rolesDescriptionsPopoverEs,
  rolesDescriptionsPopoverIt,
  rolesDescriptionsPopoverZhHans,
  rolesDescriptionsPopoverNl,
  rolesDescriptionsPopoverTr,
} from "./roles-descriptions-popover.i18n";
import {
  aiRagChatDe,
  aiRagChatEn,
  aiRagChatPtBr,
  aiRagChatEs,
  aiRagChatIt,
  aiRagChatZhHans,
  aiRagChatNl,
  aiRagChatTr,
} from "./ai-rag-chat.i18n";
import {
  supportChatDe,
  supportChatEn,
  supportChatPtBr,
  supportChatEs,
  supportChatIt,
  supportChatZhHans,
  supportChatNl,
  supportChatTr,
} from "./support-chat.i18n";
import {
  otaHistoryListDe,
  otaHistoryListEn,
  otaHistoryListPtBr,
  otaHistoryListEs,
  otaHistoryListIt,
  otaHistoryListZhHans,
  otaHistoryListNl,
  otaHistoryListTr,
} from "./ota-history-list.i18n";
import {
  otaMachineHeaderDe,
  otaMachineHeaderEn,
  otaMachineHeaderPtBr,
  otaMachineHeaderEs,
  otaMachineHeaderIt,
  otaMachineHeaderZhHans,
  otaMachineHeaderNl,
  otaMachineHeaderTr,
} from "./ota-machine-header.i18n";
import {
  otaUpdateSummaryDe,
  otaUpdateSummaryEn,
  otaUpdateSummaryPtBr,
  otaUpdateSummaryEs,
  otaUpdateSummaryIt,
  otaUpdateSummaryZhHans,
  otaUpdateSummaryNl,
  otaUpdateSummaryTr,
} from "./ota-update-summary.i18n";
import {
  otaModalDe,
  otaModalEn,
  otaModalPtBr,
  otaModalEs,
  otaModalIt,
  otaModalZhHans,
  otaModalNl,
  otaModalTr,
} from "./ota-modal-i18n";
import {
  otaNavbarDe,
  otaNavbarEn,
  otaNavbarPtBr,
  otaNavbarEs,
  otaNavbarIt,
  otaNavbarZhHans,
  otaNavbarNl,
  otaNavbarTr,
} from "./ota-navbar.i18n";
import {
  otaHistoryDe,
  otaHistoryEn,
  otaHistoryPtBr,
  otaHistoryEs,
  otaHistoryIt,
  otaHistoryZhHans,
  otaHistoryNl,
  otaHistoryTr,
} from "./ota-history.i18n";
import {
  otaReleaseNotesDe,
  otaReleaseNotesEn,
  otaReleaseNotesPtBr,
  otaReleaseNotesEs,
  otaReleaseNotesIt,
  otaReleaseNotesZhHans,
  otaReleaseNotesNl,
  otaReleaseNotesTr,
} from "./ota-release-notes.i18n";
import {
  autoTranslationButtonDe,
  autoTranslationButtonEn,
  autoTranslationButtonPtBr,
  autoTranslationButtonEs,
  autoTranslationButtonIt,
  autoTranslationButtonZhHans,
  autoTranslationButtonNl,
  autoTranslationButtonTr,
} from "./auto-translation-button.i18n";
import {
  emptyTicketsInboxTicketsPageDe,
  emptyTicketsInboxTicketsPageEn,
  emptyTicketsInboxTicketsPagePtBr,
  emptyTicketsInboxTicketsPageEs,
  emptyTicketsInboxTicketsPageIt,
  emptyTicketsInboxTicketsPageZhHans,
  emptyTicketsInboxTicketsPageNl,
  emptyTicketsInboxTicketsPageTr,
} from "./empty-tickets-inbox-tickets-page.i18n";
import {
  emptyTicketContainerTicketsPageDe,
  emptyTicketContainerTicketsPageEn,
  emptyTicketContainerTicketsPagePtBr,
  emptyTicketContainerTicketsPageEs,
  emptyTicketContainerTicketsPageIt,
  emptyTicketContainerTicketsPageZhHans,
  emptyTicketContainerTicketsPageNl,
  emptyTicketContainerTicketsPageTr,
} from "./empty-ticket-container-tickets-page.i18n";
import {
  searchDe,
  searchEn,
  searchPtBr,
  searchEs,
  searchIt,
  searchZhHans,
  searchNl,
  searchTr,
} from "./search.i18n";
import {
  addRequestTechnicalSupportDrawerModalDe,
  addRequestTechnicalSupportDrawerModalEn,
  addRequestTechnicalSupportDrawerModalPtBr,
  addRequestTechnicalSupportDrawerModalEs,
  addRequestTechnicalSupportDrawerModalIt,
  addRequestTechnicalSupportDrawerModalZhHans,
  addRequestTechnicalSupportDrawerModalNl,
  addRequestTechnicalSupportDrawerModalTr,
} from "./ticket-management-translations/add-request-technical-support-drawer-modal.i18n";
import {
  ticketSupportForMachineRowIconButtonDe,
  ticketSupportForMachineRowIconButtonEn,
  ticketSupportForMachineRowIconButtonPtBr,
  ticketSupportForMachineRowIconButtonEs,
  ticketSupportForMachineRowIconButtonIt,
  ticketSupportForMachineRowIconButtonZhHans,
  ticketSupportForMachineRowIconButtonNl,
  ticketSupportForMachineRowIconButtonTr,
} from "./ticket-support-for-machine-row-icon-button.i18n";

import {
  addRequestTechnicalSupportDrawerModalWithoutMachineDe,
  addRequestTechnicalSupportDrawerModalWithoutMachineEn,
  addRequestTechnicalSupportDrawerModalWithoutMachinePtBr,
  addRequestTechnicalSupportDrawerModalWithoutMachineEs,
  addRequestTechnicalSupportDrawerModalWithoutMachineIt,
  addRequestTechnicalSupportDrawerModalWithoutMachineZhHans,
  addRequestTechnicalSupportDrawerModalWithoutMachineNl,
  addRequestTechnicalSupportDrawerModalWithoutMachineTr,
} from "./ticket-management-translations/add-request-technical-support-drawer-modal-without-machine.i18n";
import {
  ticketListDe,
  ticketListEn,
  ticketListPtBr,
  ticketListEs,
  ticketListIt,
  ticketListZhHans,
  ticketListNl,
  ticketListTr,
} from "./ticket-list.i18n";
import {
  ticketCardDe,
  ticketCardEn,
  ticketCardPtBr,
  ticketCardEs,
  ticketCardIt,
  ticketCardZhHans,
  ticketCardNl,
  ticketCardTr,
} from "./ticket-card.i18n";
import {
  otaFirmwareVersionDrawerModalZhHans,
  otaFirmwareVersionDrawerModalDe,
  otaFirmwareVersionDrawerModalEn,
  otaFirmwareVersionDrawerModalPtBr,
  otaFirmwareVersionDrawerModalEs,
  otaFirmwareVersionDrawerModalIt,
  otaFirmwareVersionDrawerModalNl,
  otaFirmwareVersionDrawerModalTr,
} from "./ota-firmware-version-drawer-modal.i18n";
import {
  otaDrawerFormDe,
  otaDrawerFormEn,
  otaDrawerFormPtBr,
  otaDrawerFormEs,
  otaDrawerFormIt,
  otaDrawerFormZhHans,
  otaDrawerFormNl,
  otaDrawerFormTr,
} from "./ota-drawer-form.i18n";
import {
  otaDrawerMarkDownSupportDe,
  otaDrawerMarkDownSupportEn,
  otaDrawerMarkDownSupportPtBr,
  otaDrawerMarkDownSupportEs,
  otaDrawerMarkDownSupportIt,
  otaDrawerMarkDownSupportZhHans,
  otaDrawerMarkDownSupportNl,
  otaDrawerMarkDownSupportTr,
} from "./ota-drawer-markdown-support.i18n";
import {
  dropAreaAddFirmwareDe,
  dropAreaAddFirmwareEn,
  dropAreaAddFirmwarePtBr,
  dropAreaAddFirmwareEs,
  dropAreaAddFirmwareIt,
  dropAreaAddFirmwareZhHans,
  dropAreaAddFirmwareNl,
  dropAreaAddFirmwareTr,
} from "./drop-area-add-firmware.18n";
import {
  dropAreaAddImageDe,
  dropAreaAddImageEn,
  dropAreaAddImagePtBr,
  dropAreaAddImageEs,
  dropAreaAddImageIt,
  dropAreaAddImageZhHans,
  dropAreaAddImageNl,
  dropAreaAddImageTr,
} from "./drop-area-add-image.18n";
import {
  otaFirmwareBackupDrawerModalDe,
  otaFirmwareBackupDrawerModalEn,
  otaFirmwareBackupDrawerModalPtBr,
  otaFirmwareBackupDrawerModalEs,
  otaFirmwareBackupDrawerModalIt,
  otaFirmwareBackupDrawerModalZhHans,
  otaFirmwareBackupDrawerModalNl,
  otaFirmwareBackupDrawerModalTr,
} from "./ota-firmware-backup-drawer-modal.i18n";
import {
  otaDrawerInfoDe,
  otaDrawerInfoEn,
  otaDrawerInfoPtBr,
  otaDrawerInfoEs,
  otaDrawerInfoIt,
  otaDrawerInfoZhHans,
  otaDrawerInfoNl,
  otaDrawerInfoTr,
} from "./ota-drawer-info.i18n";
import {
  otaConfigurationsDrawerModalDe,
  otaConfigurationsDrawerModalEn,
  otaConfigurationsDrawerModalPtBr,
  otaConfigurationsDrawerModalEs,
  otaConfigurationsDrawerModalIt,
  otaConfigurationsDrawerModalZhHans,
  otaConfigurationsDrawerModalNl,
  otaConfigurationsDrawerModalTr,
} from "./ota-configuration-drawer-modal.i18n";
import {
  otaConfigurationBackupDrawerModalDe,
  otaConfigurationBackupDrawerModalEn,
  otaConfigurationBackupDrawerModalPtBr,
  otaConfigurationBackupDrawerModalEs,
  otaConfigurationBackupDrawerModalIt,
  otaConfigurationBackupDrawerModalZhHans,
  otaConfigurationBackupDrawerModalNl,
  otaConfigurationBackupDrawerModalTr,
} from "./ota-configuration-backup-drawer-modal.i18n";
import {
  otaConfigurationStartDe,
  otaConfigurationStartEn,
  otaConfigurationStartPtBr,
  otaConfigurationStartEs,
  otaConfigurationStartIt,
  otaConfigurationStartZhHans,
  otaConfigurationStartNl,
  otaConfigurationStartTr,
} from "./ota-configuration-start.i18n";
import {
  otaFirmwareStartDe,
  otaFirmwareStartEn,
  otaFirmwareStartPtBr,
  otaFirmwareStartEs,
  otaFirmwareStartIt,
  otaFirmwareStartZhHans,
  otaFirmwareStartNl,
  otaFirmwareStartTr,
} from "./ota-firmware-start.i18n";
import {
  otaDownloadModalDe,
  otaDownloadModalEn,
  otaDownloadModalPtBr,
  otaDownloadModalEs,
  otaDownloadModalIt,
  otaDownloadModalZhHans,
  otaDownloadModalNl,
  otaDownloadModalTr,
} from "./ota-download-modal.i18n";
import {
  otaFirmwareInstallModalDe,
  otaFirmwareInstallModalEn,
  otaFirmwareInstallModalPtBr,
  otaFirmwareInstallModalEs,
  otaFirmwareInstallModalIt,
  otaFirmwareInstallModalZhHans,
  otaFirmwareInstallModalNl,
  otaFirmwareInstallModalTr,
} from "./ota-firmware-install-modal.i18n";
import {
  otaPushFirmwareModalDe,
  otaPushFirmwareModalEn,
  otaPushFirmwareModalPtBr,
  otaPushFirmwareModalEs,
  otaPushFirmwareModalIt,
  otaPushFirmwareModalZhHans,
  otaPushFirmwareModalNl,
  otaPushFirmwareModalTr,
} from "./ota-push-firmware-modal.i18n";
import {
  otaCreateBackupModalDe,
  otaCreateBackupModalEn,
  otaCreateBackupModalPtBr,
  otaCreateBackupModalEs,
  otaCreateBackupModalIt,
  otaCreateBackupModalZhHans,
  otaCreateBackupModalNl,
  otaCreateBackupModalTr,
} from "./ota-create-backup-modal.i18n";
import {
  otaBackupProcessPendingApprovalByOperatorDe,
  otaBackupProcessPendingApprovalByOperatorEn,
  otaBackupProcessPendingApprovalByOperatorPtBr,
  otaBackupProcessPendingApprovalByOperatorEs,
  otaBackupProcessPendingApprovalByOperatorIt,
  otaBackupProcessPendingApprovalByOperatorZhHans,
  otaBackupProcessPendingApprovalByOperatorNl,
  otaBackupProcessPendingApprovalByOperatorTr,
} from "./ota-backup-process-pending-approval-by-operator.i18n";
import {
  otaBackupProcessReviewRequestAndApproveDe,
  otaBackupProcessReviewRequestAndApproveEn,
  otaBackupProcessReviewRequestAndApprovePtBr,
  otaBackupProcessReviewRequestAndApproveEs,
  otaBackupProcessReviewRequestAndApproveIt,
  otaBackupProcessReviewRequestAndApproveZhHans,
  otaBackupProcessReviewRequestAndApproveNl,
  otaBackupProcessReviewRequestAndApproveTr,
} from "./ota-backup-process-review-request-and-approve.i18n";
import {
  otaBackupProcessRequestApprovalForAdminDe,
  otaBackupProcessRequestApprovalForAdminEn,
  otaBackupProcessRequestApprovalForAdminPtBr,
  otaBackupProcessRequestApprovalForAdminEs,
  otaBackupProcessRequestApprovalForAdminIt,
  otaBackupProcessRequestApprovalForAdminZhHans,
  otaBackupProcessRequestApprovalForAdminNl,
  otaBackupProcessRequestApprovalForAdminTr,
} from "./ota-backup-process-request-approval-for-admin.i18n";
import {
  otaConfirmBackupProcessModalDe,
  otaConfirmBackupProcessModalEn,
  otaConfirmBackupProcessModalPtBr,
  otaConfirmBackupProcessModalEs,
  otaConfirmBackupProcessModalIt,
  otaConfirmBackupProcessModalZhHans,
  otaConfirmBackupProcessModalNl,
  otaConfirmBackupProcessModalTr,
} from "./ota-confirm-backup-process-modal.i18n";
import {
  otaAcceptAndCreateBackupProcessModalDe,
  otaAcceptAndCreateBackupProcessModalEn,
  otaAcceptAndCreateBackupProcessModalPtBr,
  otaAcceptAndCreateBackupProcessModalEs,
  otaAcceptAndCreateBackupProcessModalIt,
  otaAcceptAndCreateBackupProcessModalZhHans,
  otaAcceptAndCreateBackupProcessModalNl,
  otaAcceptAndCreateBackupProcessModalTr,
} from "./ota-accept-and-create-backup-process-modal.i18n";
import {
  otaBackupProcessAcceptAndCreateDe,
  otaBackupProcessAcceptAndCreateEn,
  otaBackupProcessAcceptAndCreatePtBr,
  otaBackupProcessAcceptAndCreateEs,
  otaBackupProcessAcceptAndCreateIt,
  otaBackupProcessAcceptAndCreateZhHans,
  otaBackupProcessAcceptAndCreateNl,
  otaBackupProcessAcceptAndCreateTr,
} from "./ota-backup-process-accept-and-create.i18n";
import {
  otaPushFirmwareBackupModalDe,
  otaPushFirmwareBackupModalEn,
  otaPushFirmwareBackupModalPtBr,
  otaPushFirmwareBackupModalEs,
  otaPushFirmwareBackupModalIt,
  otaPushFirmwareBackupModalZhHans,
  otaPushFirmwareBackupModalNl,
  otaPushFirmwareBackupModalTr,
} from "./ota-push-firmware-backup-modal.i18n";
import {
  otaConfirmFirmwareInstallationModalDe,
  otaConfirmFirmwareInstallationModalEn,
  otaConfirmFirmwareInstallationModalPtBr,
  otaConfirmFirmwareInstallationModalEs,
  otaConfirmFirmwareInstallationModalIt,
  otaConfirmFirmwareInstallationModalZhHans,
  otaConfirmFirmwareInstallationModalNl,
  otaConfirmFirmwareInstallationModalTr,
} from "./ota-confirm-firmware-installation-modal.i18n";
import {
  otaPendingApprovalByOperatorDe,
  otaPendingApprovalByOperatorEn,
  otaPendingApprovalByOperatorPtBr,
  otaPendingApprovalByOperatorEs,
  otaPendingApprovalByOperatorIt,
  otaPendingApprovalByOperatorZhHans,
  otaPendingApprovalByOperatorNl,
  otaPendingApprovalByOperatorTr,
} from "./ota-pending-approval-by-operator.i18n";
import {
  otaFirmwareInstallationInProgressDe,
  otaFirmwareInstallationInProgressEn,
  otaFirmwareInstallationInProgressPtBr,
  otaFirmwareInstallationInProgressEs,
  otaFirmwareInstallationInProgressIt,
  otaFirmwareInstallationInProgressZhHans,
  otaFirmwareInstallationInProgressNl,
  otaFirmwareInstallationInProgressTr,
} from "./ota-firmware-installation-in-progress.i18n";
import {
  otaBackupProcessInProgressDe,
  otaBackupProcessInProgressEn,
  otaBackupProcessInProgressPtBr,
  otaBackupProcessInProgressEs,
  otaBackupProcessInProgressIt,
  otaBackupProcessInProgressZhHans,
  otaBackupProcessInProgressNl,
  otaBackupProcessInProgressTr,
} from "./ota-backup-process-in-progress.i18n";
import {
  otaErrorBoxDe,
  otaErrorBoxEn,
  otaErrorBoxPtBr,
  otaErrorBoxEs,
  otaErrorBoxIt,
  otaErrorBoxZhHans,
  otaErrorBoxNl,
  otaErrorBoxTr,
} from "./ota-error-box.i18n";
import {
  otaInstallationInProgressModalDe,
  otaInstallationInProgressModalEn,
  otaInstallationInProgressModalPtBr,
  otaInstallationInProgressModalEs,
  otaInstallationInProgressModalIt,
  otaInstallationInProgressModalZhHans,
  otaInstallationInProgressModalNl,
  otaInstallationInProgressModalTr,
} from "./ota-installation-in-progress-modal.i18n";
import {
  otaBackupProcessInProgressModalDe,
  otaBackupProcessInProgressModalEn,
  otaBackupProcessInProgressModalPtBr,
  otaBackupProcessInProgressModalEs,
  otaBackupProcessInProgressModalIt,
  otaBackupProcessInProgressModalZhHans,
  otaBackupProcessInProgressModalNl,
  otaBackupProcessInProgressModalTr,
} from "./ota-backup-process-in-progress-modal.i18n";
import {
  otaInstallationCompleteModalDe,
  otaInstallationCompleteModalEn,
  otaInstallationCompleteModalPtBr,
  otaInstallationCompleteModalEs,
  otaInstallationCompleteModalIt,
  otaInstallationCompleteModalZhHans,
  otaInstallationCompleteModalNl,
  otaInstallationCompleteModalTr,
} from "./ota-installation-complete-modal.i18n";
import {
  otaInstallationFailedModalDe,
  otaInstallationFailedModalEn,
  otaInstallationFailedModalPtBr,
  otaInstallationFailedModalEs,
  otaInstallationFailedModalIt,
  otaInstallationFailedModalZhHans,
  otaInstallationFailedModalNl,
  otaInstallationFailedModalTr,
} from "./ota-installation-failed-modal.i18n";
import {
  otaAcceptAndPushDe,
  otaAcceptAndPushEn,
  otaAcceptAndPushPtBr,
  otaAcceptAndPushEs,
  otaAcceptAndPushIt,
  otaAcceptAndPushZhHans,
  otaAcceptAndPushNl,
  otaAcceptAndPushTr,
} from "./ota-accept-and-push.i18n";
import {
  otaAcceptAndPushFirmwareModalDe,
  otaAcceptAndPushFirmwareModalEn,
  otaAcceptAndPushFirmwareModalPtBr,
  otaAcceptAndPushFirmwareModalEs,
  otaAcceptAndPushFirmwareModalIt,
  otaAcceptAndPushFirmwareModalZhHans,
  otaAcceptAndPushFirmwareModalNl,
  otaAcceptAndPushFirmwareModalTr,
} from "./ota-accept-and-push-firmware-modal.i18n";
import {
  otaRequestForApprovalDe,
  otaRequestForApprovalEn,
  otaRequestForApprovalPtBr,
  otaRequestForApprovalEs,
  otaRequestForApprovalIt,
  otaRequestForApprovalZhHans,
  otaRequestForApprovalNl,
  otaRequestForApprovalTr,
} from "./ota-request-for-approval.i18n";
import {
  otaRequestApprovalForAdminDe,
  otaRequestApprovalForAdminEn,
  otaRequestApprovalForAdminPtBr,
  otaRequestApprovalForAdminEs,
  otaRequestApprovalForAdminIt,
  otaRequestApprovalForAdminZhHans,
  otaRequestApprovalForAdminNl,
  otaRequestApprovalForAdminTr,
} from "./ota-request-approval-for-admin.i18n";
import {
  otaFirmwareUploadModalDe,
  otaFirmwareUploadModalEn,
  otaFirmwareUploadModalPtBr,
  otaFirmwareUploadModalEs,
  otaFirmwareUploadModalIt,
  otaFirmwareUploadModalZhHans,
  otaFirmwareUploadModalNl,
  otaFirmwareUploadModalTr,
} from "./ota-firmware-uplaod-modal.i18n";
import {
  otaEmptyPlaceholderDe,
  otaEmptyPlaceholderEn,
  otaEmptyPlaceholderPtBr,
  otaEmptyPlaceholderEs,
  otaEmptyPlaceholderIt,
  otaEmptyPlaceholderZhHans,
  otaEmptyPlaceholderNl,
  otaEmptyPlaceholderTr,
} from "./ota-empty-placeholder.i18n";
import {
  markdownSupportPopoverDe,
  markdownSupportPopoverEn,
  markdownSupportPopoverPtBr,
  markdownSupportPopoverEs,
  markdownSupportPopoverIt,
  markdownSupportPopoverZhHans,
  markdownSupportPopoverNl,
  markdownSupportPopoverTr,
} from "./markdown-support-popover.i18n";
import {
  otaConfigurationUploadModalDe,
  otaConfigurationUploadModalEn,
  otaConfigurationUploadModalPtBr,
  otaConfigurationUploadModalEs,
  otaConfigurationUploadModalIt,
  otaConfigurationUploadModalZhHans,
  otaConfigurationUploadModalNl,
  otaConfigurationUploadModalTr,
} from "./ota-configuration-upload-modal.i18n";
import {
  selectedTicketViewDe,
  selectedTicketViewEn,
  selectedTicketViewPtBr,
  selectedTicketViewEs,
  selectedTicketViewIt,
  selectedTicketViewZhHans,
  selectedTicketViewNl,
  selectedTicketViewTr,
} from "./selected-ticket-view.i18n";
import {
  ticketPageChatHeaderDe,
  ticketPageChatHeaderEn,
  ticketPageChatHeaderPtBr,
  ticketPageChatHeaderEs,
  ticketPageChatHeaderIt,
  ticketPageChatHeaderZhHans,
  ticketPageChatHeaderNl,
  ticketPageChatHeaderTr,
} from "./ticket-page-chat-header.i18n";
import {
  ticketPatchUtilitiesContainerDe,
  ticketPatchUtilitiesContainerEn,
  ticketPatchUtilitiesContainerPtBr,
  ticketPatchUtilitiesContainerEs,
  ticketPatchUtilitiesContainerIt,
  ticketPatchUtilitiesContainerZhHans,
  ticketPatchUtilitiesContainerNl,
  ticketPatchUtilitiesContainerTr,
} from "./ticket-patch-utilities-container.i18n";
import {
  patchTicketPriorityDropdownDe,
  patchTicketPriorityDropdownEn,
  patchTicketPriorityDropdownPtBr,
  patchTicketPriorityDropdownEs,
  patchTicketPriorityDropdownIt,
  patchTicketPriorityDropdownZhHans,
  patchTicketPriorityDropdownNl,
  patchTicketPriorityDropdownTr,
} from "./patch-ticket-priority-dropdown.i18n";
import {
  patchTicketStatusDropdownDe,
  patchTicketStatusDropdownEn,
  patchTicketStatusDropdownPtBr,
  patchTicketStatusDropdownEs,
  patchTicketStatusDropdownIt,
  patchTicketStatusDropdownZhHans,
  patchTicketStatusDropdownNl,
  patchTicketStatusDropdownTr,
} from "./patch-ticket-status-dropdown.i18n";
import {
  patchTicketAssigneesDropdownDe,
  patchTicketAssigneesDropdownEn,
  patchTicketAssigneesDropdownPtBr,
  patchTicketAssigneesDropdownEs,
  patchTicketAssigneesDropdownIt,
  patchTicketAssigneesDropdownZhHans,
  patchTicketAssigneesDropdownNl,
  patchTicketAssigneesDropdownTr,
} from "./patch-ticket-assignees-dropdown.i18n";
import {
  nodeManagerNavigationButtonsDe,
  nodeManagerNavigationButtonsEn,
  nodeManagerNavigationButtonsPtBr,
  nodeManagerNavigationButtonsEs,
  nodeManagerNavigationButtonsIt,
  nodeManagerNavigationButtonsZhHans,
  nodeManagerNavigationButtonsNl,
  nodeManagerNavigationButtonsTr,
} from "./node-manager-navigation-buttons.i18n";
import {
  otaConfigurationInstallModalDe,
  otaConfigurationInstallModalEn,
  otaConfigurationInstallModalPtBr,
  otaConfigurationInstallModalEs,
  otaConfigurationInstallModalIt,
  otaConfigurationInstallModalZhHans,
  otaConfigurationInstallModalNl,
  otaConfigurationInstallModalTr,
} from "./ota-configuration-install-modal.i18n";
import {
  alarmsNotificationsDrawerModalDe,
  alarmsNotificationsDrawerModalEn,
  alarmsNotificationsDrawerModalPtBr,
  alarmsNotificationsDrawerModalEs,
  alarmsNotificationsDrawerModalIt,
  alarmsNotificationsDrawerModalZhHans,
  alarmsNotificationsDrawerModalNl,
  alarmsNotificationsDrawerModalTr,
} from "./alarm-notifications-drawer-modal.i18n";
import {
  otaBackupStartDe,
  otaBackupStartEn,
  otaBackupStartPtBr,
  otaBackupStartEs,
  otaBackupStartIt,
  otaBackupStartZhHans,
  otaBackupStartNl,
  otaBackupStartTr,
} from "./ota-backup-start.i18n";
import {
  infoButtonDe,
  infoButtonEn,
  infoButtonPtBr,
  infoButtonEs,
  infoButtonIt,
  infoButtonZhHans,
  infoButtonNl,
  infoButtonTr,
} from "./info-button.i18n";
import {
  taskbarDe,
  taskbarEn,
  taskbarPtBr,
  taskbarEs,
  taskbarIt,
  taskbarZhHans,
  taskbarNl,
  taskbarTr,
} from "./taskbar.i18n";
import {
  ticketsTaskbarCardDe,
  ticketsTaskbarCardEn,
  ticketsTaskbarCardPtBr,
  ticketsTaskbarCardEs,
  ticketsTaskbarCardIt,
  ticketsTaskbarCardZhHans,
  ticketsTaskbarCardNl,
  ticketsTaskbarCardTr,
} from "./tickets-taskbar-card.i18n";
import {
  taskbarTicketsHistoryPopoverDe,
  taskbarTicketsHistoryPopoverEn,
  taskbarTicketsHistoryPopoverPtBr,
  taskbarTicketsHistoryPopoverEs,
  taskbarTicketsHistoryPopoverIt,
  taskbarTicketsHistoryPopoverZhHans,
  taskbarTicketsHistoryPopoverNl,
  taskbarTicketsHistoryPopoverTr,
} from "./taskbar-tickets-history-popover.i18n";

import {
  sseEn,
  ssePtBr,
  sseEs,
  sseIt,
  sseDe,
  sseZhHans,
  sseNl,
  sseTr,
} from "./sse.i18n";
import {
  supportChatModalDe,
  supportChatModalEn,
  supportChatModalPtBr,
  supportChatModalEs,
  supportChatModalIt,
  supportChatModalZhHans,
  supportChatModalNl,
  supportChatModalTr,
} from "./support-chat-modal.i18n";
import {
  gatewayServiceUsersListDe,
  gatewayServiceUsersListEn,
  gatewayServiceUsersListPtBr,
  gatewayServiceUsersListEs,
  gatewayServiceUsersListIt,
  gatewayServiceUsersListZhHans,
  gatewayServiceUsersListNl,
  gatewayServiceUsersListTr,
} from "./gateway-service-users-list.i18n";

import {
  thingsHubSearchEn,
  thingsHubSearchPtBr,
  thingsHubSearchEs,
  thingsHubSearchDe,
  thingsHubSearchZhHans,
  thingsHubSearchIt,
  thingsHubSearchNl,
  thingsHubSearchTr,
} from "./things-hub-search.i18n";

import {
  thingsHubDragAndDropEn,
  thingsHubDragAndDropPtBr,
  thingsHubDragAndDropEs,
  thingsHubDragAndDropDe,
  thingsHubDragAndDropZhHans,
  thingsHubDragAndDropIt,
  thingsHubDragAndDropNl,
  thingsHubDragAndDropTr,
} from "./things-hub-drag-and-drop.i18n";

import {
  filteredNodeOurNodeDe,
  filteredNodeOurNodeEn,
  filteredNodeOurNodeEs,
  filteredNodeOurNodeIt,
  filteredNodeOurNodePtBr,
  filteredNodeOurNodeZhHans,
  filteredNodeOurNodeNl,
  filteredNodeOurNodeTr,
} from "./filter-node-our-node.i18n";
import {
  datePickerDe,
  datePickerEn,
  datePickerEs,
  datePickerIt,
  datePickerNl,
  datePickerPtBr,
  datePickerZhHans,
  datePickerTr,
} from "./date-picker.i18n";

export const englishModules = {
  ...addNewGatewayDrawerModalEn,
  ...addNewMachineDrawerModalEn,
  ...addServiceUserDrawerModalEn,
  ...addUserDrawerModalEn,
  ...addRequestTechnicalSupportDrawerModalEn,
  ...addRequestTechnicalSupportDrawerModalWithoutMachineEn,
  ...alarmsNotificationsDrawerModalEn,
  ...aiRagChatEn,
  ...supportChatEn,
  ...userCredentialsModalEn,
  ...alarmListEn,
  ...alarmListHeaderEn,
  ...alarmListNodeEn,
  ...alarmListToolbarEn,
  ...alarmNodeDetailsPanelEn,
  ...alarmProfileCardEn,
  ...alarmProfileEmailRecipientsDrawerModalEn,
  ...alarmProfileEmailRecipientsListEn,
  ...alarmProfilePopoverEn,
  ...alarmProfilesDrawerModalEn,
  ...applyAutoMatchBlueprintEn,
  ...applyMyBlueprintLibraryEn,
  ...autoTranslationButtonEn,
  ...backIconButtonWithTextEn,
  ...bigBlueprintBannerEn,
  ...bigBlueprintBannerAutoMatchEn,
  ...blueprintDescriptionPopoverEn,
  ...blueprintStateInfoBannerAuthorDateWrapperEn,
  ...blueprintStateInfoBannerBlueprintNameVerifiedWrapperEn,
  ...blueprintStateInfoBannerDataAcquisitionSummaryWrapperEn,
  ...blueprintStateInfoBannerModalsButtonsWrapperEn,
  ...blueprintStateInfoBannerRestructuringCounterEn,
  ...blueprintStateInfoBannerRestructuringSummaryWrapperEn,
  ...blueprintTableBodyFlexWrapperWithVerifiedIconEn,
  ...blueprintsTableEn,
  ...blueprintUnassignedWarningIgnoreButtonWrapperEn,
  ...bulkEditDataAcquisitionModalEn,
  ...buttonWithIconEn,
  ...editWidgetDrawerModalEn,
  ...multipleTextValuesEn,
  ...counterNumberEn,
  ...trendLineEn,
  ...multiLineEn,
  ...lookbackAndPollingFieldsEn,
  ...scaleInputEn,
  ...checkBoxTextWrapperEn,
  ...dashboardCardEn,
  ...dashboardTileGridEn,
  ...dashboardThemeEditorEn,
  ...checkedUnorderedListEn,
  ...checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertEn,
  ...connectedGatewaysListContainerEn,
  ...copyAccessTokenLinkEn,
  ...customerNamespaceStringEn,
  ...dashboardGraphPanelContentEn,
  ...dashboardPanelEn,
  ...dragImageEn,
  ...drawerIconContainerEn,
  ...drawerModalEn,
  ...factoryDashboardPageEn,
  ...dropAreaEn,
  ...dropDownLanguageEn,
  ...editGatewayNameEn,
  ...editServiceUserDrawerModalEn,
  ...editSourceNameEn,
  ...editUserDrawerModalEn,
  ...emptyTicketsInboxTicketsPageEn,
  ...emptyTicketContainerTicketsPageEn,
  ...enableDisableAllBlueprintDashboardTogglesEn,
  ...enableDisableAllBlueprintDashboardTogglesEn,
  ...errorPaneEn,
  ...filteredMissingNodesPillButtonEn,
  ...filterIconEn,
  ...findAutoMatchBlueprintEn,
  ...findMyBlueprintLibraryModalEn,
  ...foundAllNodesPillBoxEn,
  ...gatewayServiceUsersListViewEn,
  ...gatewaysListHeaderEn,
  ...gatewaysListRowEn,
  ...gatewaysListViewEn,
  ...gatewayServiceUsersListEn,
  ...helpButtonEn,
  ...iconButtonEn,
  ...iconButtonWithTextEn,
  ...indicatorTextEn,
  ...infoIconAndTextEn,
  ...autoGenerateCertificateSettingEn,
  ...initialStructurePanelEn,
  ...initialStructureFilterEn,
  ...languageSelectorWithSearchEn,
  ...timezoneDateEn,
  ...timezoneSelectorWithSearchEn,
  ...logoutTimerEn,
  ...machineStructureFilterEn,
  ...machineStructurePanelControlBarEn,
  ...machineStructurePanelEn,
  ...machineOverviewContainerEn,
  ...machineOverviewContainerDrBoyEn,
  ...staticMachineOverviewContainerForTtEn,
  ...machineOverviewWidgetEn,
  ...nameInputOurNodeEn,
  ...nameOurNodeEn,
  ...navigationEn,
  ...adminPanelSidebarEn,
  ...organizationsViewAdminPanelEn,
  ...addMachineGroupsAdminPanelModalEn,
  ...machineGroupsViewAdminPanelEn,
  ...cleanupViewAdminPanelEn,
  ...machineGroupsListAdminPanelEn,
  ...machineGroupExpandedViewEn,
  ...organizationsTableAdminPanelEn,
  ...adminPanelPageEn,
  ...newTransferConfigurationToClientEn,
  ...nodesCounterSelectorEn,
  ...noGatewaysDetectedViewEn,
  ...noMachinesDetectedViewEn,
  ...nodeManagerInfoBarPillsNavEn,
  ...oneShotEn,
  ...shotTableEn,
  ...ourNodeAncestorsLineageTreeEn,
  ...ourNodeDetailsPanelEn,
  ...dashboardTimeseriesInfoWithPopoverEn,
  ...overwriteStructureWarningModalEn,
  ...pleaseWaitWhileProcessingEn,
  ...questionMarkPopoverEn,
  ...questionMarkWithPopoverForConditionMonitoringEn,
  ...questionMarkWithPopoverForGatewaysEn,
  ...readOnlyConnectedSourceViewEn,
  ...renderOnlyForDevelopersInfoEn,
  ...renderRestructuringSummaryNodesPillElementEn,
  ...renderUnreleasedFeaturesInfoEn,
  ...replaceBlueprintGradientBoxEn,
  ...replaceBlueprintGradientBoxDescriptionContainerEn,
  ...replaceBlueprintGradientBoxInfoContainerEn,
  ...replaceBlueprintModalEn,
  ...resolvedAllNodesPillButtonEn,
  ...rolesSelectorEn,
  ...rolesDescriptionsPopoverEn,
  ...saveBlueprintModalEn,
  ...scanInterruptionModalEn,
  ...selectedItemsHiddenTextEn,
  ...selectedTicketViewEn,
  ...serviceUsersListEn,
  ...serviceUsersListViewEn,
  ...smallBlueprintBannerAutoMatchEn,
  ...snackbarNotificationsEn,
  ...sourceInfoDrawerModalEn,
  ...gatewayMachinesListHeaderEn,
  ...gatewayMachineListRowEn,
  ...sourcesInfoWithPopoverEn,
  ...searchEn,
  ...ticketCardEn,
  ...ticketListEn,
  ...ticketSupportForMachineRowIconButtonEn,
  ...tileEn,
  ...tileFormEn,
  ...tileDrawerModalEn,
  ...timeIntervalInputAndDropDownWrapperEn,
  ...timeSeriesDataTypeEn,
  ...timeSeriesLineNoDataEn,
  ...noDataInTimeframeEn,
  ...timestampsAndStringsDataTableEn,
  ...transferButtonEn,
  ...transferConfigurationToClientButtonEn,
  ...treeViewNoOurNodeMachineStructureDragAndDropEn,
  ...tsidContainerEn,
  ...twoFactorAuthenticationButtonsWrapperEn,
  ...unassignedFilterViewTitleIgnoreAllButtonWrapperEn,
  ...unitInputAndPopoverEn,
  ...unfilteredMissingNodesPillButtonEn,
  ...unsavedConditionMonitoringForNodeManagerNavigationModalEn,
  ...unsavedStructureForNodeManagerNavigationModalEn,
  ...unsavedStructureModalEn,
  ...userManagementListPillsNavEn,
  ...usersListEn,
  ...usersListViewEn,
  ...userStatusWithSwitchEn,
  ...validateUserDrawerInputsUtilEn,
  ...versionStringInfoEn,
  ...timezoneStringInfoEn,
  ...machinesRequestRemoteMachineAccessDrawerModalEn,
  ...machinesRemoteSupportActiveButtonEn,
  ...machinesRemoteSupportRequestedButtonEn,
  ...machinesCancelRequestDisconnectSupportModalEn,
  ...machinesCancelRequestCrossModalEn,
  ...vpnManagerByRolePageEn,
  ...machinesListEn,
  ...machinesListHeaderExpandCollapseAllEn,
  ...machinesListRowEn,
  ...machinesListWithCompaniesEn,
  ...vncCountdownBarEn,
  ...zendeskContactUrlEn,
  ...otaHistoryListEn,
  ...otaMachineHeaderEn,
  ...otaUpdateSummaryEn,
  ...otaModalEn,
  ...otaNavbarEn,
  ...otaHistoryEn,
  ...otaReleaseNotesEn,
  ...otaFirmwareVersionDrawerModalEn,
  ...otaDrawerFormEn,
  ...otaDrawerMarkDownSupportEn,
  ...dropAreaAddFirmwareEn,
  ...dropAreaAddImageEn,
  ...otaFirmwareBackupDrawerModalEn,
  ...otaDrawerInfoEn,
  ...otaConfigurationsDrawerModalEn,
  ...otaConfigurationBackupDrawerModalEn,
  ...otaConfigurationStartEn,
  ...otaFirmwareStartEn,
  ...otaDownloadModalEn,
  ...otaFirmwareInstallModalEn,
  ...otaPushFirmwareModalEn,
  ...otaCreateBackupModalEn,
  ...otaBackupProcessPendingApprovalByOperatorEn,
  ...otaBackupProcessReviewRequestAndApproveEn,
  ...otaBackupProcessRequestApprovalForAdminEn,
  ...otaConfirmBackupProcessModalEn,
  ...otaAcceptAndCreateBackupProcessModalEn,
  ...otaBackupProcessAcceptAndCreateEn,
  ...otaPushFirmwareBackupModalEn,
  ...otaFirmwareUploadModalEn,
  ...otaConfigurationUploadModalEn,
  ...otaEmptyPlaceholderEn,
  ...markdownSupportPopoverEn,
  ...ticketPageChatHeaderEn,
  ...ticketPatchUtilitiesContainerEn,
  ...patchTicketPriorityDropdownEn,
  ...patchTicketStatusDropdownEn,
  ...patchTicketAssigneesDropdownEn,
  ...nodeManagerNavigationButtonsEn,
  ...otaConfigurationInstallModalEn,
  ...otaBackupStartEn,
  ...otaAbortInstallEn,
  ...otaConfirmFirmwareInstallationModalEn,
  ...otaPendingApprovalByOperatorEn,
  ...otaFirmwareInstallationInProgressEn,
  ...otaBackupProcessInProgressEn,
  ...otaErrorBoxEn,
  ...otaInstallationInProgressModalEn,
  ...otaBackupProcessInProgressModalEn,
  ...otaInstallationCompleteModalEn,
  ...otaInstallationFailedModalEn,
  ...otaAcceptAndPushEn,
  ...otaAcceptAndPushFirmwareModalEn,
  ...otaRequestForApprovalEn,
  ...otaRequestApprovalForAdminEn,
  ...infoButtonEn,
  ...taskbarEn,
  ...ticketsTaskbarCardEn,
  ...taskbarTicketsHistoryPopoverEn,
  ...sseEn,
  ...supportChatModalEn,
  ...thingsHubSearchEn,
  ...thingsHubDragAndDropEn,
  ...filteredNodeOurNodeEn,
  ...datePickerEn,
  ...staticHeaderEn,
  ...staticTextEn,
  ...staticLinkEn,
  ...staticSeparatorEn,
  ...machineOverviewEn,
  ...shotDataLineChartEn,
  ...singleTextValueEn,
};

export const brazilianPortugueseModules = {
  ...addNewGatewayDrawerModalPtBr,
  ...addNewMachineDrawerModalPtBr,
  ...addServiceUserDrawerModalPtBr,
  ...addUserDrawerModalPtBr,
  ...addRequestTechnicalSupportDrawerModalPtBr,
  ...addRequestTechnicalSupportDrawerModalWithoutMachinePtBr,
  ...alarmsNotificationsDrawerModalPtBr,
  ...aiRagChatPtBr,
  ...supportChatPtBr,
  ...userCredentialsModalPtBr,
  ...alarmListPtBr,
  ...alarmListHeaderPtBr,
  ...alarmListNodePtBr,
  ...alarmListToolbarPtBr,
  ...alarmNodeDetailsPanelPtBr,
  ...alarmProfileCardPtBr,
  ...alarmProfileEmailRecipientsDrawerModalPtBr,
  ...alarmProfileEmailRecipientsListPtBr,
  ...alarmProfilePopoverPtBr,
  ...alarmProfilesDrawerModalPtBr,
  ...applyAutoMatchBlueprintPtBr,
  ...applyMyBlueprintLibraryPtBr,
  ...autoTranslationButtonPtBr,
  ...backIconButtonWithTextPtBr,
  ...bigBlueprintBannerPtBr,
  ...bigBlueprintBannerAutoMatchPtBr,
  ...blueprintDescriptionPopoverPtBr,
  ...blueprintStateInfoBannerAuthorDateWrapperPtBr,
  ...blueprintStateInfoBannerBlueprintNameVerifiedWrapperPtBr,
  ...blueprintStateInfoBannerDataAcquisitionSummaryWrapperPtBr,
  ...blueprintStateInfoBannerModalsButtonsWrapperPtBr,
  ...blueprintStateInfoBannerRestructuringCounterPtBr,
  ...blueprintStateInfoBannerRestructuringSummaryWrapperPtBr,
  ...blueprintTableBodyFlexWrapperWithVerifiedIconPtBr,
  ...blueprintsTablePtBr,
  ...blueprintUnassignedWarningIgnoreButtonWrapperPtBr,
  ...bulkEditDataAcquisitionModalPtBr,
  ...buttonWithIconPtBr,
  ...editWidgetDrawerModalPtBr,
  ...multipleTextValuesPtBr,
  ...counterNumberPtBr,
  ...trendLinePtBr,
  ...multiLinePtBr,
  ...lookbackAndPollingFieldsPtBr,
  ...scaleInputPtBr,
  ...checkBoxTextWrapperPtBr,
  ...dashboardCardPtBr,
  ...dashboardTileGridPtBr,
  ...dashboardThemeEditorPtBr,
  ...checkedUnorderedListPtBr,
  ...checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertPtBr,
  ...connectedGatewaysListContainerPtBr,
  ...copyAccessTokenLinkPtBr,
  ...customerNamespaceStringPtBr,
  ...dashboardGraphPanelContentPtBr,
  ...dashboardPanelPtBr,
  ...dragImagePtBr,
  ...drawerIconContainerPtBr,
  ...drawerModalPtBr,
  ...factoryDashboardPagePtBr,
  ...dropAreaPtBr,
  ...dropDownLanguagePtBr,
  ...editGatewayNamePtBr,
  ...editServiceUserDrawerModalPtBr,
  ...editSourceNamePtBr,
  ...editUserDrawerModalPtBr,
  ...emptyTicketsInboxTicketsPagePtBr,
  ...emptyTicketContainerTicketsPagePtBr,
  ...enableDisableAllBlueprintDashboardTogglesPtBr,
  ...enableDisableAllBlueprintDashboardTogglesPtBr,
  ...errorPanePtBr,
  ...filteredMissingNodesPillButtonPtBr,
  ...filterIconPtBr,
  ...findAutoMatchBlueprintPtBr,
  ...findMyBlueprintLibraryModalPtBr,
  ...foundAllNodesPillBoxPtBr,
  ...gatewayServiceUsersListViewPtBr,
  ...gatewaysListHeaderPtBr,
  ...gatewaysListRowPtBr,
  ...gatewaysListViewPtBr,
  ...gatewayServiceUsersListPtBr,
  ...helpButtonPtBr,
  ...iconButtonPtBr,
  ...iconButtonWithTextPtBr,
  ...indicatorTextPtBr,
  ...infoIconAndTextPtBr,
  ...autoGenerateCertificateSettingPtBr,
  ...initialStructurePanelPtBr,
  ...initialStructureFilterPtBr,
  ...languageSelectorWithSearchPtBr,
  ...timezoneDatePtBr,
  ...timezoneSelectorWithSearchPtBr,
  ...logoutTimerPtBr,
  ...machineStructureFilterPtBr,
  ...machineStructurePanelControlBarPtBr,
  ...machineStructurePanelPtBr,
  ...machineOverviewContainerPtBr,
  ...machineOverviewContainerDrBoyPtBr,
  ...staticMachineOverviewContainerForTtPtBr,
  ...machineOverviewWidgetPtBr,
  ...nameInputOurNodePtBr,
  ...nameOurNodePtBr,
  ...navigationPtBr,
  ...adminPanelSidebarPtBr,
  ...organizationsViewAdminPanelPtBr,
  ...addMachineGroupsAdminPanelModalPtBr,
  ...machineGroupsViewAdminPanelPtBr,
  ...cleanupViewAdminPanelPtBr,
  ...machineGroupsListAdminPanelPtBr,
  ...machineGroupExpandedViewPtBr,
  ...organizationsTableAdminPanelPtBr,
  ...adminPanelPagePtBr,
  ...newTransferConfigurationToClientPtBr,
  ...nodesCounterSelectorPtBr,
  ...noGatewaysDetectedViewPtBr,
  ...noMachinesDetectedViewPtBr,
  ...nodeManagerInfoBarPillsNavPtBr,
  ...oneShotPtBr,
  ...shotTablePtBr,
  ...ourNodeAncestorsLineageTreePtBr,
  ...ourNodeDetailsPanelPtBr,
  ...dashboardTimeseriesInfoWithPopoverPtBr,
  ...overwriteStructureWarningModalPtBr,
  ...pleaseWaitWhileProcessingPtBr,
  ...questionMarkPopoverPtBr,
  ...questionMarkWithPopoverForConditionMonitoringPtBr,
  ...questionMarkWithPopoverForGatewaysPtBr,
  ...readOnlyConnectedSourceViewPtBr,
  ...renderOnlyForDevelopersInfoPtBr,
  ...renderRestructuringSummaryNodesPillElementPtBr,
  ...renderUnreleasedFeaturesInfoPtBr,
  ...replaceBlueprintGradientBoxPtBr,
  ...replaceBlueprintGradientBoxDescriptionContainerPtBr,
  ...replaceBlueprintGradientBoxInfoContainerPtBr,
  ...replaceBlueprintModalPtBr,
  ...resolvedAllNodesPillButtonPtBr,
  ...rolesSelectorPtBr,
  ...rolesDescriptionsPopoverPtBr,
  ...saveBlueprintModalPtBr,
  ...scanInterruptionModalPtBr,
  ...selectedItemsHiddenTextPtBr,
  ...selectedTicketViewPtBr,
  ...serviceUsersListPtBr,
  ...serviceUsersListViewPtBr,
  ...smallBlueprintBannerAutoMatchPtBr,
  ...snackbarNotificationsPtBr,
  ...sourceInfoDrawerModalPtBr,
  ...gatewayMachinesListHeaderPtBr,
  ...gatewayMachineListRowPtBr,
  ...sourcesInfoWithPopoverPtBr,
  ...searchPtBr,
  ...ticketCardPtBr,
  ...ticketListPtBr,
  ...ticketSupportForMachineRowIconButtonPtBr,
  ...tilePtBr,
  ...tileFormPtBr,
  ...tileDrawerModalPtBr,
  ...timeIntervalInputAndDropDownWrapperPtBr,
  ...timeSeriesDataTypePtBr,
  ...timeSeriesLineNoDataPtBr,
  ...noDataInTimeframePtBr,
  ...timestampsAndStringsDataTablePtBr,
  ...transferButtonPtBr,
  ...transferConfigurationToClientButtonPtBr,
  ...treeViewNoOurNodeMachineStructureDragAndDropPtBr,
  ...tsidContainerPtBr,
  ...twoFactorAuthenticationButtonsWrapperPtBr,
  ...unassignedFilterViewTitleIgnoreAllButtonWrapperPtBr,
  ...unitInputAndPopoverPtBr,
  ...unfilteredMissingNodesPillButtonPtBr,
  ...unsavedConditionMonitoringForNodeManagerNavigationModalPtBr,
  ...unsavedStructureForNodeManagerNavigationModalPtBr,
  ...unsavedStructureModalPtBr,
  ...userManagementListPillsNavPtBr,
  ...usersListPtBr,
  ...usersListViewPtBr,
  ...userStatusWithSwitchPtBr,
  ...validateUserDrawerInputsUtilPtBr,
  ...versionStringInfoPtBr,
  ...timezoneStringInfoPtBr,
  ...machinesRequestRemoteMachineAccessDrawerModalPtBr,
  ...machinesRemoteSupportActiveButtonPtBr,
  ...machinesRemoteSupportRequestedButtonPtBr,
  ...machinesCancelRequestDisconnectSupportModalPtBr,
  ...machinesCancelRequestCrossModalPtBr,
  ...vpnManagerByRolePagePtBr,
  ...machinesListPtBr,
  ...machinesListHeaderExpandCollapseAllPtBr,
  ...machinesListRowPtBr,
  ...machinesListWithCompaniesPtBr,
  ...vncCountdownBarPtBr,
  ...zendeskContactUrlPtBr,
  ...otaHistoryListPtBr,
  ...otaMachineHeaderPtBr,
  ...otaUpdateSummaryPtBr,
  ...otaModalPtBr,
  ...otaNavbarPtBr,
  ...otaHistoryPtBr,
  ...otaReleaseNotesPtBr,
  ...otaFirmwareVersionDrawerModalPtBr,
  ...otaDrawerFormPtBr,
  ...otaDrawerMarkDownSupportPtBr,
  ...dropAreaAddFirmwarePtBr,
  ...dropAreaAddImagePtBr,
  ...otaFirmwareBackupDrawerModalPtBr,
  ...otaDrawerInfoPtBr,
  ...otaConfigurationsDrawerModalPtBr,
  ...otaConfigurationBackupDrawerModalPtBr,
  ...otaConfigurationStartPtBr,
  ...otaFirmwareStartPtBr,
  ...otaDownloadModalPtBr,
  ...otaFirmwareInstallModalPtBr,
  ...otaPushFirmwareModalPtBr,
  ...otaCreateBackupModalPtBr,
  ...otaBackupProcessPendingApprovalByOperatorPtBr,
  ...otaBackupProcessReviewRequestAndApprovePtBr,
  ...otaBackupProcessRequestApprovalForAdminPtBr,
  ...otaConfirmBackupProcessModalPtBr,
  ...otaAcceptAndCreateBackupProcessModalPtBr,
  ...otaBackupProcessAcceptAndCreatePtBr,
  ...otaPushFirmwareBackupModalPtBr,
  ...otaFirmwareUploadModalPtBr,
  ...otaConfigurationUploadModalPtBr,
  ...otaEmptyPlaceholderPtBr,
  ...markdownSupportPopoverPtBr,
  ...ticketPageChatHeaderPtBr,
  ...ticketPatchUtilitiesContainerPtBr,
  ...patchTicketPriorityDropdownPtBr,
  ...patchTicketStatusDropdownPtBr,
  ...patchTicketAssigneesDropdownPtBr,
  ...nodeManagerNavigationButtonsPtBr,
  ...otaConfigurationInstallModalPtBr,
  ...otaBackupStartPtBr,
  ...otaAbortInstallPtBr,
  ...otaConfirmFirmwareInstallationModalPtBr,
  ...otaPendingApprovalByOperatorPtBr,
  ...otaFirmwareInstallationInProgressPtBr,
  ...otaBackupProcessInProgressPtBr,
  ...otaErrorBoxPtBr,
  ...otaInstallationInProgressModalPtBr,
  ...otaBackupProcessInProgressModalPtBr,
  ...otaInstallationCompleteModalPtBr,
  ...otaInstallationFailedModalPtBr,
  ...otaAcceptAndPushPtBr,
  ...otaAcceptAndPushFirmwareModalPtBr,
  ...otaRequestForApprovalPtBr,
  ...otaRequestApprovalForAdminPtBr,
  ...infoButtonPtBr,
  ...taskbarPtBr,
  ...ticketsTaskbarCardPtBr,
  ...taskbarTicketsHistoryPopoverPtBr,
  ...ssePtBr,
  ...supportChatModalPtBr,
  ...thingsHubSearchPtBr,
  ...thingsHubDragAndDropPtBr,
  ...filteredNodeOurNodePtBr,
  ...datePickerPtBr,
  ...staticHeaderPtBr,
  ...staticTextPtBr,
  ...staticLinkPtBr,
  ...staticSeparatorPtBr,
  ...machineOverviewPtBr,
  ...shotDataLineChartPtBr,
  ...singleTextValuePtBr,
};

export const germanModules = {
  ...addNewGatewayDrawerModalDe,
  ...addNewMachineDrawerModalDe,
  ...addServiceUserDrawerModalDe,
  ...addUserDrawerModalDe,
  ...addRequestTechnicalSupportDrawerModalDe,
  ...addRequestTechnicalSupportDrawerModalWithoutMachineDe,
  ...alarmsNotificationsDrawerModalDe,
  ...aiRagChatDe,
  ...supportChatDe,
  ...userCredentialsModalDe,
  ...alarmListDe,
  ...alarmListHeaderDe,
  ...alarmListNodeDe,
  ...alarmListToolbarDe,
  ...alarmNodeDetailsPanelDe,
  ...alarmProfileCardDe,
  ...alarmProfileEmailRecipientsDrawerModalDe,
  ...alarmProfileEmailRecipientsListDe,
  ...alarmProfilePopoverDe,
  ...alarmProfilesDrawerModalDe,
  ...applyAutoMatchBlueprintDe,
  ...applyMyBlueprintLibraryDe,
  ...autoTranslationButtonDe,
  ...backIconButtonWithTextDe,
  ...bigBlueprintBannerDe,
  ...bigBlueprintBannerAutoMatchDe,
  ...blueprintDescriptionPopoverDe,
  ...blueprintStateInfoBannerAuthorDateWrapperDe,
  ...blueprintStateInfoBannerBlueprintNameVerifiedWrapperDe,
  ...blueprintStateInfoBannerDataAcquisitionSummaryWrapperDe,
  ...blueprintStateInfoBannerModalsButtonsWrapperDe,
  ...blueprintStateInfoBannerRestructuringCounterDe,
  ...blueprintStateInfoBannerRestructuringSummaryWrapperDe,
  ...blueprintTableBodyFlexWrapperWithVerifiedIconDe,
  ...blueprintsTableDe,
  ...blueprintUnassignedWarningIgnoreButtonWrapperDe,
  ...bulkEditDataAcquisitionModalDe,
  ...buttonWithIconDe,
  ...editWidgetDrawerModalDe,
  ...multipleTextValuesDe,
  ...counterNumberDe,
  ...trendLineDe,
  ...multiLineDe,
  ...lookbackAndPollingFieldsDe,
  ...scaleInputDe,
  ...checkBoxTextWrapperDe,
  ...dashboardCardDe,
  ...dashboardTileGridDe,
  ...dashboardThemeEditorDe,
  ...checkedUnorderedListDe,
  ...checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertDe,
  ...connectedGatewaysListContainerDe,
  ...copyAccessTokenLinkDe,
  ...customerNamespaceStringDe,
  ...dashboardGraphPanelContentDe,
  ...dashboardPanelDe,
  ...dragImageDe,
  ...drawerIconContainerDe,
  ...drawerModalDe,
  ...factoryDashboardPageDe,
  ...dropAreaDe,
  ...dropDownLanguageDe,
  ...editGatewayNameDe,
  ...editServiceUserDrawerModalDe,
  ...editSourceNameDe,
  ...editUserDrawerModalDe,
  ...emptyTicketsInboxTicketsPageDe,
  ...emptyTicketContainerTicketsPageDe,
  ...enableDisableAllBlueprintDashboardTogglesDe,
  ...enableDisableAllBlueprintDashboardTogglesDe,
  ...errorPaneDe,
  ...filteredMissingNodesPillButtonDe,
  ...filterIconDe,
  ...findAutoMatchBlueprintDe,
  ...findMyBlueprintLibraryModalDe,
  ...foundAllNodesPillBoxDe,
  ...gatewayServiceUsersListViewDe,
  ...gatewaysListHeaderDe,
  ...gatewaysListRowDe,
  ...gatewaysListViewDe,
  ...gatewayServiceUsersListDe,
  ...helpButtonDe,
  ...iconButtonDe,
  ...iconButtonWithTextDe,
  ...indicatorTextDe,
  ...infoIconAndTextDe,
  ...autoGenerateCertificateSettingDe,
  ...initialStructurePanelDe,
  ...initialStructureFilterDe,
  ...languageSelectorWithSearchDe,
  ...timezoneDateDe,
  ...timezoneSelectorWithSearchDe,
  ...logoutTimerDe,
  ...machineStructureFilterDe,
  ...machineStructurePanelControlBarDe,
  ...machineStructurePanelDe,
  ...machineOverviewContainerDe,
  ...machineOverviewContainerDrBoyDe,
  ...staticMachineOverviewContainerForTtDe,
  ...machineOverviewWidgetDe,
  ...nameInputOurNodeDe,
  ...nameOurNodeDe,
  ...navigationDe,
  ...adminPanelSidebarDe,
  ...organizationsViewAdminPanelDe,
  ...addMachineGroupsAdminPanelModalDe,
  ...machineGroupsViewAdminPanelDe,
  ...cleanupViewAdminPanelDe,
  ...machineGroupsListAdminPanelDe,
  ...machineGroupExpandedViewDe,
  ...organizationsTableAdminPanelDe,
  ...adminPanelPageDe,
  ...newTransferConfigurationToClientDe,
  ...nodesCounterSelectorDe,
  ...noGatewaysDetectedViewDe,
  ...noMachinesDetectedViewDe,
  ...nodeManagerInfoBarPillsNavDe,
  ...oneShotDe,
  ...shotTableDe,
  ...ourNodeAncestorsLineageTreeDe,
  ...ourNodeDetailsPanelDe,
  ...dashboardTimeseriesInfoWithPopoverDe,
  ...overwriteStructureWarningModalDe,
  ...pleaseWaitWhileProcessingDe,
  ...questionMarkPopoverDe,
  ...questionMarkWithPopoverForConditionMonitoringDe,
  ...questionMarkWithPopoverForGatewaysDe,
  ...readOnlyConnectedSourceViewDe,
  ...renderOnlyForDevelopersInfoDe,
  ...renderRestructuringSummaryNodesPillElementDe,
  ...renderUnreleasedFeaturesInfoDe,
  ...replaceBlueprintGradientBoxDe,
  ...replaceBlueprintGradientBoxDescriptionContainerDe,
  ...replaceBlueprintGradientBoxInfoContainerDe,
  ...replaceBlueprintModalDe,
  ...resolvedAllNodesPillButtonDe,
  ...rolesDescriptionsPopoverDe,
  ...rolesSelectorDe,
  ...saveBlueprintModalDe,
  ...scanInterruptionModalDe,
  ...selectedItemsHiddenTextDe,
  ...selectedTicketViewDe,
  ...serviceUsersListDe,
  ...serviceUsersListViewDe,
  ...smallBlueprintBannerAutoMatchDe,
  ...snackbarNotificationsDe,
  ...sourceInfoDrawerModalDe,
  ...gatewayMachinesListHeaderDe,
  ...gatewayMachineListRowDe,
  ...sourcesInfoWithPopoverDe,
  ...searchDe,
  ...ticketCardDe,
  ...ticketListDe,
  ...ticketSupportForMachineRowIconButtonDe,
  ...tileDe,
  ...tileFormDe,
  ...tileDrawerModalDe,
  ...timeIntervalInputAndDropDownWrapperDe,
  ...timeSeriesLineNoDataDe,
  ...noDataInTimeframeDe,
  ...timeSeriesDataTypeDe,
  ...timestampsAndStringsDataTableDe,
  ...transferButtonDe,
  ...transferConfigurationToClientButtonDe,
  ...treeViewNoOurNodeMachineStructureDragAndDropDe,
  ...tsidContainerDe,
  ...twoFactorAuthenticationButtonsWrapperDe,
  ...unassignedFilterViewTitleIgnoreAllButtonWrapperDe,
  ...unitInputAndPopoverDe,
  ...unfilteredMissingNodesPillButtonDe,
  ...unsavedConditionMonitoringForNodeManagerNavigationModalDe,
  ...unsavedStructureForNodeManagerNavigationModalDe,
  ...unsavedStructureModalDe,
  ...userManagementListPillsNavDe,
  ...usersListDe,
  ...usersListViewDe,
  ...userStatusWithSwitchDe,
  ...validateUserDrawerInputsUtilDe,
  ...versionStringInfoDe,
  ...timezoneStringInfoDe,
  ...machinesRequestRemoteMachineAccessDrawerModalDe,
  ...machinesRemoteSupportActiveButtonDe,
  ...machinesRemoteSupportRequestedButtonDe,
  ...machinesCancelRequestDisconnectSupportModalDe,
  ...machinesCancelRequestCrossModalDe,
  ...vpnManagerByRolePageDe,
  ...machinesListDe,
  ...machinesListHeaderExpandCollapseAllDe,
  ...machinesListRowDe,
  ...machinesListWithCompaniesDe,
  ...vncCountdownBarDe,
  ...zendeskContactUrlDe,
  ...otaHistoryListDe,
  ...otaMachineHeaderDe,
  ...otaUpdateSummaryDe,
  ...otaModalDe,
  ...otaNavbarDe,
  ...otaHistoryDe,
  ...otaReleaseNotesDe,
  ...otaFirmwareVersionDrawerModalDe,
  ...otaDrawerFormDe,
  ...otaDrawerMarkDownSupportDe,
  ...dropAreaAddFirmwareDe,
  ...dropAreaAddImageDe,
  ...otaFirmwareBackupDrawerModalDe,
  ...otaDrawerInfoDe,
  ...otaConfigurationsDrawerModalDe,
  ...otaConfigurationBackupDrawerModalDe,
  ...otaConfigurationStartDe,
  ...otaFirmwareStartDe,
  ...otaDownloadModalDe,
  ...otaFirmwareInstallModalDe,
  ...otaPushFirmwareModalDe,
  ...otaCreateBackupModalDe,
  ...otaBackupProcessPendingApprovalByOperatorDe,
  ...otaBackupProcessReviewRequestAndApproveDe,
  ...otaBackupProcessRequestApprovalForAdminDe,
  ...otaConfirmBackupProcessModalDe,
  ...otaAcceptAndCreateBackupProcessModalDe,
  ...otaBackupProcessAcceptAndCreateDe,
  ...otaPushFirmwareBackupModalDe,
  ...otaFirmwareUploadModalDe,
  ...otaConfigurationUploadModalDe,
  ...otaEmptyPlaceholderDe,
  ...markdownSupportPopoverDe,
  ...ticketPageChatHeaderDe,
  ...ticketPatchUtilitiesContainerDe,
  ...patchTicketPriorityDropdownDe,
  ...patchTicketStatusDropdownDe,
  ...patchTicketAssigneesDropdownDe,
  ...nodeManagerNavigationButtonsDe,
  ...otaConfigurationInstallModalDe,
  ...otaBackupStartDe,
  ...otaAbortInstallDe,
  ...otaConfirmFirmwareInstallationModalDe,
  ...otaPendingApprovalByOperatorDe,
  ...otaFirmwareInstallationInProgressDe,
  ...otaBackupProcessInProgressDe,
  ...otaErrorBoxDe,
  ...otaInstallationInProgressModalDe,
  ...otaBackupProcessInProgressModalDe,
  ...otaInstallationCompleteModalDe,
  ...otaInstallationFailedModalDe,
  ...otaAcceptAndPushDe,
  ...otaAcceptAndPushFirmwareModalDe,
  ...otaRequestForApprovalDe,
  ...otaRequestApprovalForAdminDe,
  ...infoButtonDe,
  ...taskbarDe,
  ...ticketsTaskbarCardDe,
  ...taskbarTicketsHistoryPopoverDe,
  ...sseDe,
  ...supportChatModalDe,
  ...thingsHubSearchDe,
  ...thingsHubDragAndDropDe,
  ...filteredNodeOurNodeDe,
  ...datePickerDe,
  ...staticHeaderDe,
  ...staticTextDe,
  ...staticLinkDe,
  ...staticSeparatorDe,
  ...machineOverviewDe,
  ...shotDataLineChartDe,
  ...singleTextValueDe,
};

export const simplifiedChineseModules = {
  ...addNewGatewayDrawerModalZhHans,
  ...addNewMachineDrawerModalZhHans,
  ...addServiceUserDrawerModalZhHans,
  ...addUserDrawerModalZhHans,
  ...addRequestTechnicalSupportDrawerModalZhHans,
  ...addRequestTechnicalSupportDrawerModalWithoutMachineZhHans,
  ...alarmsNotificationsDrawerModalZhHans,
  ...aiRagChatZhHans,
  ...supportChatZhHans,
  ...userCredentialsModalZhHans,
  ...alarmListZhHans,
  ...alarmListHeaderZhHans,
  ...alarmListNodeZhHans,
  ...alarmListToolbarZhHans,
  ...alarmNodeDetailsPanelZhHans,
  ...alarmProfileCardZhHans,
  ...alarmProfileEmailRecipientsDrawerModalZhHans,
  ...alarmProfileEmailRecipientsListZhHans,
  ...alarmProfilePopoverZhHans,
  ...alarmProfilesDrawerModalZhHans,
  ...applyAutoMatchBlueprintZhHans,
  ...applyMyBlueprintLibraryZhHans,
  ...autoTranslationButtonZhHans,
  ...backIconButtonWithTextZhHans,
  ...bigBlueprintBannerZhHans,
  ...bigBlueprintBannerAutoMatchZhHans,
  ...blueprintDescriptionPopoverZhHans,
  ...blueprintStateInfoBannerAuthorDateWrapperZhHans,
  ...blueprintStateInfoBannerBlueprintNameVerifiedWrapperZhHans,
  ...blueprintStateInfoBannerDataAcquisitionSummaryWrapperZhHans,
  ...blueprintStateInfoBannerModalsButtonsWrapperZhHans,
  ...blueprintStateInfoBannerRestructuringCounterZhHans,
  ...blueprintStateInfoBannerRestructuringSummaryWrapperZhHans,
  ...blueprintTableBodyFlexWrapperWithVerifiedIconZhHans,
  ...blueprintsTableZhHans,
  ...blueprintUnassignedWarningIgnoreButtonWrapperZhHans,
  ...bulkEditDataAcquisitionModalZhHans,
  ...buttonWithIconZhHans,
  ...editWidgetDrawerModalZhHans,
  ...multipleTextValuesZhHans,
  ...counterNumberZhHans,
  ...trendLineZhHans,
  ...multiLineZhHans,
  ...lookbackAndPollingFieldsZhHans,
  ...scaleInputZhHans,
  ...checkBoxTextWrapperZhHans,
  ...dashboardCardZhHans,
  ...dashboardTileGridZhHans,
  ...dashboardThemeEditorZhHans,
  ...checkedUnorderedListZhHans,
  ...checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertZhHans,
  ...connectedGatewaysListContainerZhHans,
  ...copyAccessTokenLinkZhHans,
  ...customerNamespaceStringZhHans,
  ...dashboardGraphPanelContentZhHans,
  ...dashboardPanelZhHans,
  ...dragImageZhHans,
  ...drawerIconContainerZhHans,
  ...drawerModalZhHans,
  ...factoryDashboardPageZhHans,
  ...dropAreaZhHans,
  ...dropDownLanguageZhHans,
  ...editGatewayNameZhHans,
  ...editServiceUserDrawerModalZhHans,
  ...editSourceNameZhHans,
  ...editUserDrawerModalZhHans,
  ...emptyTicketsInboxTicketsPageZhHans,
  ...emptyTicketContainerTicketsPageZhHans,
  ...enableDisableAllBlueprintDashboardTogglesZhHans,
  ...errorPaneZhHans,
  ...filteredMissingNodesPillButtonZhHans,
  ...filterIconZhHans,
  ...findAutoMatchBlueprintZhHans,
  ...findMyBlueprintLibraryModalZhHans,
  ...foundAllNodesPillBoxZhHans,
  ...gatewayServiceUsersListViewZhHans,
  ...gatewaysListHeaderZhHans,
  ...gatewaysListRowZhHans,
  ...gatewaysListViewZhHans,
  ...gatewayServiceUsersListZhHans,
  ...helpButtonZhHans,
  ...iconButtonZhHans,
  ...iconButtonWithTextZhHans,
  ...indicatorTextZhHans,
  ...infoIconAndTextZhHans,
  ...autoGenerateCertificateSettingZhHans,
  ...initialStructurePanelZhHans,
  ...initialStructureFilterZhHans,
  ...languageSelectorWithSearchZhHans,
  ...timezoneDateZhHans,
  ...timezoneSelectorWithSearchZhHans,
  ...logoutTimerZhHans,
  ...machineStructureFilterZhHans,
  ...machineStructurePanelControlBarZhHans,
  ...machineStructurePanelZhHans,
  ...machineOverviewContainerZhHans,
  ...machineOverviewContainerDrBoyZhHans,
  ...staticMachineOverviewContainerForTtZhHans,
  ...machineOverviewWidgetZhHans,
  ...nameInputOurNodeZhHans,
  ...nameOurNodeZhHans,
  ...navigationZhHans,
  ...adminPanelSidebarZhHans,
  ...organizationsViewAdminPanelZhHans,
  ...addMachineGroupsAdminPanelModalZhHans,
  ...machineGroupsViewAdminPanelZhHans,
  ...cleanupViewAdminPanelZhHans,
  ...machineGroupsListAdminPanelZhHans,
  ...machineGroupExpandedViewZhHans,
  ...organizationsTableAdminPanelZhHans,
  ...adminPanelPageZhHans,
  ...newTransferConfigurationToClientZhHans,
  ...noGatewaysDetectedViewZhHans,
  ...nodesCounterSelectorZhHans,
  ...nodeManagerInfoBarPillsNavZhHans,
  ...noMachinesDetectedViewZhHans,
  ...oneShotZhHans,
  ...shotTableZhHans,
  ...ourNodeAncestorsLineageTreeZhHans,
  ...ourNodeDetailsPanelZhHans,
  ...dashboardTimeseriesInfoWithPopoverZhHans,
  ...overwriteStructureWarningModalZhHans,
  ...pleaseWaitWhileProcessingZhHans,
  ...questionMarkPopoverZhHans,
  ...questionMarkWithPopoverForConditionMonitoringZhHans,
  ...questionMarkWithPopoverForGatewaysZhHans,
  ...readOnlyConnectedSourceViewZhHans,
  ...renderOnlyForDevelopersInfoZhHans,
  ...renderRestructuringSummaryNodesPillElementZhHans,
  ...renderUnreleasedFeaturesInfoZhHans,
  ...replaceBlueprintGradientBoxZhHans,
  ...replaceBlueprintGradientBoxDescriptionContainerZhHans,
  ...replaceBlueprintGradientBoxInfoContainerZhHans,
  ...replaceBlueprintModalZhHans,
  ...resolvedAllNodesPillButtonZhHans,
  ...rolesDescriptionsPopoverZhHans,
  ...rolesSelectorZhHans,
  ...saveBlueprintModalZhHans,
  ...scanInterruptionModalZhHans,
  ...selectedItemsHiddenTextZhHans,
  ...serviceUsersListZhHans,
  ...serviceUsersListViewZhHans,
  ...smallBlueprintBannerAutoMatchZhHans,
  ...snackbarNotificationsZhHans,
  ...sourceInfoDrawerModalZhHans,
  ...gatewayMachinesListHeaderZhHans,
  ...gatewayMachineListRowZhHans,
  ...sourcesInfoWithPopoverZhHans,
  ...searchZhHans,
  ...selectedTicketViewZhHans,
  ...ticketCardZhHans,
  ...ticketListZhHans,
  ...ticketSupportForMachineRowIconButtonZhHans,
  ...tileZhHans,
  ...tileFormZhHans,
  ...tileDrawerModalZhHans,
  ...timeIntervalInputAndDropDownWrapperZhHans,
  ...timeSeriesDataTypeZhHans,
  ...timeSeriesLineNoDataZhHans,
  ...noDataInTimeframeZhHans,
  ...timestampsAndStringsDataTableZhHans,
  ...transferButtonZhHans,
  ...transferConfigurationToClientButtonZhHans,
  ...treeViewNoOurNodeMachineStructureDragAndDropZhHans,
  ...tsidContainerZhHans,
  ...twoFactorAuthenticationButtonsWrapperZhHans,
  ...unassignedFilterViewTitleIgnoreAllButtonWrapperZhHans,
  ...unitInputAndPopoverZhHans,
  ...unfilteredMissingNodesPillButtonZhHans,
  ...unsavedConditionMonitoringForNodeManagerNavigationModalZhHans,
  ...unsavedStructureForNodeManagerNavigationModalZhHans,
  ...unsavedStructureModalZhHans,
  ...userManagementListPillsNavZhHans,
  ...usersListZhHans,
  ...usersListViewZhHans,
  ...userStatusWithSwitchZhHans,
  ...validateUserDrawerInputsUtilZhHans,
  ...versionStringInfoZhHans,
  ...timezoneStringInfoZhHans,
  ...machinesRequestRemoteMachineAccessDrawerModalZhHans,
  ...machinesRemoteSupportActiveButtonZhHans,
  ...machinesRemoteSupportRequestedButtonZhHans,
  ...machinesCancelRequestDisconnectSupportModalZhHans,
  ...machinesCancelRequestCrossModalZhHans,
  ...vpnManagerByRolePageZhHans,
  ...machinesListZhHans,
  ...machinesListHeaderExpandCollapseAllZhHans,
  ...machinesListRowZhHans,
  ...machinesListWithCompaniesZhHans,
  ...vncCountdownBarZhHans,
  ...zendeskContactUrlZhHans,
  ...otaHistoryListZhHans,
  ...otaMachineHeaderZhHans,
  ...otaUpdateSummaryZhHans,
  ...otaModalZhHans,
  ...otaNavbarZhHans,
  ...otaHistoryZhHans,
  ...otaReleaseNotesZhHans,
  ...otaFirmwareVersionDrawerModalZhHans,
  ...otaDrawerFormZhHans,
  ...otaDrawerMarkDownSupportZhHans,
  ...dropAreaAddFirmwareZhHans,
  ...dropAreaAddImageZhHans,
  ...otaFirmwareBackupDrawerModalZhHans,
  ...otaDrawerInfoZhHans,
  ...otaConfigurationsDrawerModalZhHans,
  ...otaConfigurationBackupDrawerModalZhHans,
  ...otaConfigurationStartZhHans,
  ...otaFirmwareStartZhHans,
  ...otaDownloadModalZhHans,
  ...otaFirmwareInstallModalZhHans,
  ...otaPushFirmwareModalZhHans,
  ...otaCreateBackupModalZhHans,
  ...otaBackupProcessPendingApprovalByOperatorZhHans,
  ...otaBackupProcessReviewRequestAndApproveZhHans,
  ...otaBackupProcessRequestApprovalForAdminZhHans,
  ...otaConfirmBackupProcessModalZhHans,
  ...otaAcceptAndCreateBackupProcessModalZhHans,
  ...otaBackupProcessAcceptAndCreateZhHans,
  ...otaPushFirmwareBackupModalZhHans,
  ...otaFirmwareUploadModalZhHans,
  ...otaConfigurationUploadModalZhHans,
  ...otaEmptyPlaceholderZhHans,
  ...markdownSupportPopoverZhHans,
  ...ticketPageChatHeaderZhHans,
  ...ticketPatchUtilitiesContainerZhHans,
  ...patchTicketPriorityDropdownZhHans,
  ...patchTicketStatusDropdownZhHans,
  ...patchTicketAssigneesDropdownZhHans,
  ...otaConfigurationInstallModalZhHans,
  ...nodeManagerNavigationButtonsZhHans,
  ...otaBackupStartZhHans,
  ...otaAbortInstallZhHans,
  ...otaConfirmFirmwareInstallationModalZhHans,
  ...otaPendingApprovalByOperatorZhHans,
  ...otaFirmwareInstallationInProgressZhHans,
  ...otaBackupProcessInProgressZhHans,
  ...otaErrorBoxZhHans,
  ...otaInstallationInProgressModalZhHans,
  ...otaBackupProcessInProgressModalZhHans,
  ...otaInstallationCompleteModalZhHans,
  ...otaInstallationFailedModalZhHans,
  ...otaAcceptAndPushZhHans,
  ...otaAcceptAndPushFirmwareModalZhHans,
  ...otaRequestForApprovalZhHans,
  ...otaRequestApprovalForAdminZhHans,
  ...infoButtonZhHans,
  ...taskbarZhHans,
  ...ticketsTaskbarCardZhHans,
  ...taskbarTicketsHistoryPopoverZhHans,
  ...sseZhHans,
  ...supportChatModalZhHans,
  ...thingsHubSearchZhHans,
  ...thingsHubDragAndDropZhHans,
  ...filteredNodeOurNodeZhHans,
  ...datePickerZhHans,
  ...staticHeaderZhHans,
  ...staticTextZhHans,
  ...staticLinkZhHans,
  ...staticSeparatorZhHans,
  ...machineOverviewZhHans,
  ...shotDataLineChartZhHans,
  ...singleTextValueZhHans,
};

// Italian locale enabled with English fallback until dedicated Italian copy is added.
export const spanishModules = {
  ...addNewGatewayDrawerModalEs,
  ...addNewMachineDrawerModalEs,
  ...addServiceUserDrawerModalEs,
  ...addUserDrawerModalEs,
  ...addRequestTechnicalSupportDrawerModalEs,
  ...addRequestTechnicalSupportDrawerModalWithoutMachineEs,
  ...alarmsNotificationsDrawerModalEs,
  ...aiRagChatEs,
  ...supportChatEs,
  ...userCredentialsModalEs,
  ...alarmListEs,
  ...alarmListHeaderEs,
  ...alarmListNodeEs,
  ...alarmListToolbarEs,
  ...alarmNodeDetailsPanelEs,
  ...alarmProfileCardEs,
  ...alarmProfileEmailRecipientsDrawerModalEs,
  ...alarmProfileEmailRecipientsListEs,
  ...alarmProfilePopoverEs,
  ...alarmProfilesDrawerModalEs,
  ...applyAutoMatchBlueprintEs,
  ...applyMyBlueprintLibraryEs,
  ...autoTranslationButtonEs,
  ...backIconButtonWithTextEs,
  ...bigBlueprintBannerEs,
  ...bigBlueprintBannerAutoMatchEs,
  ...blueprintDescriptionPopoverEs,
  ...blueprintStateInfoBannerAuthorDateWrapperEs,
  ...blueprintStateInfoBannerBlueprintNameVerifiedWrapperEs,
  ...blueprintStateInfoBannerDataAcquisitionSummaryWrapperEs,
  ...blueprintStateInfoBannerModalsButtonsWrapperEs,
  ...blueprintStateInfoBannerRestructuringCounterEs,
  ...blueprintStateInfoBannerRestructuringSummaryWrapperEs,
  ...blueprintTableBodyFlexWrapperWithVerifiedIconEs,
  ...blueprintsTableEs,
  ...blueprintUnassignedWarningIgnoreButtonWrapperEs,
  ...bulkEditDataAcquisitionModalEs,
  ...buttonWithIconEs,
  ...editWidgetDrawerModalEs,
  ...multipleTextValuesEs,
  ...counterNumberEs,
  ...trendLineEs,
  ...multiLineEs,
  ...lookbackAndPollingFieldsEs,
  ...scaleInputEs,
  ...checkBoxTextWrapperEs,
  ...dashboardCardEs,
  ...dashboardTileGridEs,
  ...dashboardThemeEditorEs,
  ...checkedUnorderedListEs,
  ...checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertEs,
  ...connectedGatewaysListContainerEs,
  ...copyAccessTokenLinkEs,
  ...customerNamespaceStringEs,
  ...dashboardGraphPanelContentEs,
  ...dashboardPanelEs,
  ...dragImageEs,
  ...drawerIconContainerEs,
  ...drawerModalEs,
  ...factoryDashboardPageEs,
  ...dropAreaEs,
  ...dropDownLanguageEs,
  ...editGatewayNameEs,
  ...editServiceUserDrawerModalEs,
  ...editSourceNameEs,
  ...editUserDrawerModalEs,
  ...emptyTicketsInboxTicketsPageEs,
  ...emptyTicketContainerTicketsPageEs,
  ...enableDisableAllBlueprintDashboardTogglesEs,
  ...enableDisableAllBlueprintDashboardTogglesEs,
  ...errorPaneEs,
  ...filteredMissingNodesPillButtonEs,
  ...filterIconEs,
  ...findAutoMatchBlueprintEs,
  ...findMyBlueprintLibraryModalEs,
  ...foundAllNodesPillBoxEs,
  ...gatewayServiceUsersListViewEs,
  ...gatewaysListHeaderEs,
  ...gatewaysListRowEs,
  ...gatewaysListViewEs,
  ...gatewayServiceUsersListEs,
  ...helpButtonEs,
  ...iconButtonEs,
  ...iconButtonWithTextEs,
  ...indicatorTextEs,
  ...infoIconAndTextEs,
  ...autoGenerateCertificateSettingEs,
  ...initialStructurePanelEs,
  ...initialStructureFilterEs,
  ...languageSelectorWithSearchEs,
  ...timezoneDateEs,
  ...timezoneSelectorWithSearchEs,
  ...logoutTimerEs,
  ...machineStructureFilterEs,
  ...machineStructurePanelControlBarEs,
  ...machineStructurePanelEs,
  ...machineOverviewContainerEs,
  ...machineOverviewContainerDrBoyEs,
  ...staticMachineOverviewContainerForTtEs,
  ...machineOverviewWidgetEs,
  ...nameInputOurNodeEs,
  ...nameOurNodeEs,
  ...navigationEs,
  ...adminPanelSidebarEs,
  ...organizationsViewAdminPanelEs,
  ...addMachineGroupsAdminPanelModalEs,
  ...machineGroupsViewAdminPanelEs,
  ...cleanupViewAdminPanelEs,
  ...machineGroupsListAdminPanelEs,
  ...machineGroupExpandedViewEs,
  ...organizationsTableAdminPanelEs,
  ...adminPanelPageEs,
  ...newTransferConfigurationToClientEs,
  ...nodesCounterSelectorEs,
  ...noGatewaysDetectedViewEs,
  ...noMachinesDetectedViewEs,
  ...nodeManagerInfoBarPillsNavEs,
  ...oneShotEs,
  ...shotTableEs,
  ...ourNodeAncestorsLineageTreeEs,
  ...ourNodeDetailsPanelEs,
  ...dashboardTimeseriesInfoWithPopoverEs,
  ...overwriteStructureWarningModalEs,
  ...pleaseWaitWhileProcessingEs,
  ...questionMarkPopoverEs,
  ...questionMarkWithPopoverForConditionMonitoringEs,
  ...questionMarkWithPopoverForGatewaysEs,
  ...readOnlyConnectedSourceViewEs,
  ...renderOnlyForDevelopersInfoEs,
  ...renderRestructuringSummaryNodesPillElementEs,
  ...renderUnreleasedFeaturesInfoEs,
  ...replaceBlueprintGradientBoxEs,
  ...replaceBlueprintGradientBoxDescriptionContainerEs,
  ...replaceBlueprintGradientBoxInfoContainerEs,
  ...replaceBlueprintModalEs,
  ...resolvedAllNodesPillButtonEs,
  ...rolesSelectorEs,
  ...rolesDescriptionsPopoverEs,
  ...saveBlueprintModalEs,
  ...scanInterruptionModalEs,
  ...selectedItemsHiddenTextEs,
  ...selectedTicketViewEs,
  ...serviceUsersListEs,
  ...serviceUsersListViewEs,
  ...smallBlueprintBannerAutoMatchEs,
  ...snackbarNotificationsEs,
  ...sourceInfoDrawerModalEs,
  ...gatewayMachinesListHeaderEs,
  ...gatewayMachineListRowEs,
  ...sourcesInfoWithPopoverEs,
  ...searchEs,
  ...ticketCardEs,
  ...ticketListEs,
  ...ticketSupportForMachineRowIconButtonEs,
  ...tileEs,
  ...tileFormEs,
  ...tileDrawerModalEs,
  ...timeIntervalInputAndDropDownWrapperEs,
  ...timeSeriesDataTypeEs,
  ...timeSeriesLineNoDataEs,
  ...noDataInTimeframeEs,
  ...timestampsAndStringsDataTableEs,
  ...transferButtonEs,
  ...transferConfigurationToClientButtonEs,
  ...treeViewNoOurNodeMachineStructureDragAndDropEs,
  ...tsidContainerEs,
  ...twoFactorAuthenticationButtonsWrapperEs,
  ...unassignedFilterViewTitleIgnoreAllButtonWrapperEs,
  ...unitInputAndPopoverEs,
  ...unfilteredMissingNodesPillButtonEs,
  ...unsavedConditionMonitoringForNodeManagerNavigationModalEs,
  ...unsavedStructureForNodeManagerNavigationModalEs,
  ...unsavedStructureModalEs,
  ...userManagementListPillsNavEs,
  ...usersListEs,
  ...usersListViewEs,
  ...userStatusWithSwitchEs,
  ...validateUserDrawerInputsUtilEs,
  ...versionStringInfoEs,
  ...timezoneStringInfoEs,
  ...machinesRequestRemoteMachineAccessDrawerModalEs,
  ...machinesRemoteSupportActiveButtonEs,
  ...machinesRemoteSupportRequestedButtonEs,
  ...machinesCancelRequestDisconnectSupportModalEs,
  ...machinesCancelRequestCrossModalEs,
  ...vpnManagerByRolePageEs,
  ...machinesListEs,
  ...machinesListHeaderExpandCollapseAllEs,
  ...machinesListRowEs,
  ...machinesListWithCompaniesEs,
  ...vncCountdownBarEs,
  ...zendeskContactUrlEs,
  ...otaHistoryListEs,
  ...otaMachineHeaderEs,
  ...otaUpdateSummaryEs,
  ...otaModalEs,
  ...otaNavbarEs,
  ...otaHistoryEs,
  ...otaReleaseNotesEs,
  ...otaFirmwareVersionDrawerModalEs,
  ...otaDrawerFormEs,
  ...otaDrawerMarkDownSupportEs,
  ...dropAreaAddFirmwareEs,
  ...dropAreaAddImageEs,
  ...otaFirmwareBackupDrawerModalEs,
  ...otaDrawerInfoEs,
  ...otaConfigurationsDrawerModalEs,
  ...otaConfigurationBackupDrawerModalEs,
  ...otaConfigurationStartEs,
  ...otaFirmwareStartEs,
  ...otaDownloadModalEs,
  ...otaFirmwareInstallModalEs,
  ...otaPushFirmwareModalEs,
  ...otaCreateBackupModalEs,
  ...otaBackupProcessPendingApprovalByOperatorEs,
  ...otaBackupProcessReviewRequestAndApproveEs,
  ...otaBackupProcessRequestApprovalForAdminEs,
  ...otaConfirmBackupProcessModalEs,
  ...otaAcceptAndCreateBackupProcessModalEs,
  ...otaBackupProcessAcceptAndCreateEs,
  ...otaPushFirmwareBackupModalEs,
  ...otaFirmwareUploadModalEs,
  ...otaConfigurationUploadModalEs,
  ...otaEmptyPlaceholderEs,
  ...markdownSupportPopoverEs,
  ...ticketPageChatHeaderEs,
  ...ticketPatchUtilitiesContainerEs,
  ...patchTicketPriorityDropdownEs,
  ...patchTicketStatusDropdownEs,
  ...patchTicketAssigneesDropdownEs,
  ...nodeManagerNavigationButtonsEs,
  ...otaConfigurationInstallModalEs,
  ...otaBackupStartEs,
  ...otaAbortInstallEs,
  ...otaConfirmFirmwareInstallationModalEs,
  ...otaPendingApprovalByOperatorEs,
  ...otaFirmwareInstallationInProgressEs,
  ...otaBackupProcessInProgressEs,
  ...otaErrorBoxEs,
  ...otaInstallationInProgressModalEs,
  ...otaBackupProcessInProgressModalEs,
  ...otaInstallationCompleteModalEs,
  ...otaInstallationFailedModalEs,
  ...otaAcceptAndPushEs,
  ...otaAcceptAndPushFirmwareModalEs,
  ...otaRequestForApprovalEs,
  ...otaRequestApprovalForAdminEs,
  ...infoButtonEs,
  ...taskbarEs,
  ...ticketsTaskbarCardEs,
  ...taskbarTicketsHistoryPopoverEs,
  ...sseEs,
  ...supportChatModalEs,
  ...thingsHubSearchEs,
  ...thingsHubDragAndDropEs,
  ...filteredNodeOurNodeEs,
  ...datePickerEs,
  ...staticHeaderEs,
  ...staticTextEs,
  ...staticLinkEs,
  ...staticSeparatorEs,
  ...machineOverviewEs,
  ...shotDataLineChartEs,
  ...singleTextValueEs,
};

export const italianModules = {
  ...addNewGatewayDrawerModalIt,
  ...addNewMachineDrawerModalIt,
  ...addServiceUserDrawerModalIt,
  ...addUserDrawerModalIt,
  ...addRequestTechnicalSupportDrawerModalIt,
  ...addRequestTechnicalSupportDrawerModalWithoutMachineIt,
  ...alarmsNotificationsDrawerModalIt,
  ...aiRagChatIt,
  ...supportChatIt,
  ...userCredentialsModalIt,
  ...alarmListIt,
  ...alarmListHeaderIt,
  ...alarmListNodeIt,
  ...alarmListToolbarIt,
  ...alarmNodeDetailsPanelIt,
  ...alarmProfileCardIt,
  ...alarmProfileEmailRecipientsDrawerModalIt,
  ...alarmProfileEmailRecipientsListIt,
  ...alarmProfilePopoverIt,
  ...alarmProfilesDrawerModalIt,
  ...applyAutoMatchBlueprintIt,
  ...applyMyBlueprintLibraryIt,
  ...autoTranslationButtonIt,
  ...backIconButtonWithTextIt,
  ...bigBlueprintBannerIt,
  ...bigBlueprintBannerAutoMatchIt,
  ...blueprintDescriptionPopoverIt,
  ...blueprintStateInfoBannerAuthorDateWrapperIt,
  ...blueprintStateInfoBannerBlueprintNameVerifiedWrapperIt,
  ...blueprintStateInfoBannerDataAcquisitionSummaryWrapperIt,
  ...blueprintStateInfoBannerModalsButtonsWrapperIt,
  ...blueprintStateInfoBannerRestructuringCounterIt,
  ...blueprintStateInfoBannerRestructuringSummaryWrapperIt,
  ...blueprintTableBodyFlexWrapperWithVerifiedIconIt,
  ...blueprintsTableIt,
  ...blueprintUnassignedWarningIgnoreButtonWrapperIt,
  ...bulkEditDataAcquisitionModalIt,
  ...buttonWithIconIt,
  ...editWidgetDrawerModalIt,
  ...multipleTextValuesIt,
  ...counterNumberIt,
  ...trendLineIt,
  ...multiLineIt,
  ...lookbackAndPollingFieldsIt,
  ...scaleInputIt,
  ...checkBoxTextWrapperIt,
  ...dashboardCardIt,
  ...dashboardTileGridIt,
  ...dashboardThemeEditorIt,
  ...checkedUnorderedListIt,
  ...checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertIt,
  ...connectedGatewaysListContainerIt,
  ...copyAccessTokenLinkIt,
  ...customerNamespaceStringIt,
  ...dashboardGraphPanelContentIt,
  ...dashboardPanelIt,
  ...dragImageIt,
  ...drawerIconContainerIt,
  ...drawerModalIt,
  ...factoryDashboardPageIt,
  ...dropAreaIt,
  ...dropDownLanguageIt,
  ...editGatewayNameIt,
  ...editServiceUserDrawerModalIt,
  ...editSourceNameIt,
  ...editUserDrawerModalIt,
  ...emptyTicketsInboxTicketsPageIt,
  ...emptyTicketContainerTicketsPageIt,
  ...enableDisableAllBlueprintDashboardTogglesIt,
  ...enableDisableAllBlueprintDashboardTogglesIt,
  ...errorPaneIt,
  ...filteredMissingNodesPillButtonIt,
  ...filterIconIt,
  ...findAutoMatchBlueprintIt,
  ...findMyBlueprintLibraryModalIt,
  ...foundAllNodesPillBoxIt,
  ...gatewayServiceUsersListViewIt,
  ...gatewaysListHeaderIt,
  ...gatewayServiceUsersListIt,
  ...gatewaysListRowIt,
  ...gatewaysListViewIt,
  ...helpButtonIt,
  ...iconButtonIt,
  ...iconButtonWithTextIt,
  ...indicatorTextIt,
  ...infoIconAndTextIt,
  ...autoGenerateCertificateSettingIt,
  ...initialStructurePanelIt,
  ...initialStructureFilterIt,
  ...languageSelectorWithSearchIt,
  ...timezoneDateIt,
  ...timezoneSelectorWithSearchIt,
  ...logoutTimerIt,
  ...machineStructureFilterIt,
  ...machineStructurePanelControlBarIt,
  ...machineStructurePanelIt,
  ...machineOverviewContainerIt,
  ...machineOverviewContainerDrBoyIt,
  ...staticMachineOverviewContainerForTtIt,
  ...machineOverviewWidgetIt,
  ...nameInputOurNodeIt,
  ...nameOurNodeIt,
  ...navigationIt,
  ...adminPanelSidebarIt,
  ...organizationsViewAdminPanelIt,
  ...addMachineGroupsAdminPanelModalIt,
  ...machineGroupsViewAdminPanelIt,
  ...cleanupViewAdminPanelIt,
  ...machineGroupsListAdminPanelIt,
  ...machineGroupExpandedViewIt,
  ...organizationsTableAdminPanelIt,
  ...adminPanelPageIt,
  ...newTransferConfigurationToClientIt,
  ...nodesCounterSelectorIt,
  ...noGatewaysDetectedViewIt,
  ...noMachinesDetectedViewIt,
  ...nodeManagerInfoBarPillsNavIt,
  ...oneShotIt,
  ...shotTableIt,
  ...ourNodeAncestorsLineageTreeIt,
  ...ourNodeDetailsPanelIt,
  ...dashboardTimeseriesInfoWithPopoverIt,
  ...overwriteStructureWarningModalIt,
  ...pleaseWaitWhileProcessingIt,
  ...questionMarkPopoverIt,
  ...questionMarkWithPopoverForConditionMonitoringIt,
  ...questionMarkWithPopoverForGatewaysIt,
  ...readOnlyConnectedSourceViewIt,
  ...renderOnlyForDevelopersInfoIt,
  ...renderRestructuringSummaryNodesPillElementIt,
  ...renderUnreleasedFeaturesInfoIt,
  ...replaceBlueprintGradientBoxIt,
  ...replaceBlueprintGradientBoxDescriptionContainerIt,
  ...replaceBlueprintGradientBoxInfoContainerIt,
  ...replaceBlueprintModalIt,
  ...resolvedAllNodesPillButtonIt,
  ...rolesSelectorIt,
  ...rolesDescriptionsPopoverIt,
  ...saveBlueprintModalIt,
  ...scanInterruptionModalIt,
  ...selectedItemsHiddenTextIt,
  ...selectedTicketViewIt,
  ...serviceUsersListIt,
  ...serviceUsersListViewIt,
  ...smallBlueprintBannerAutoMatchIt,
  ...snackbarNotificationsIt,
  ...sourceInfoDrawerModalIt,
  ...gatewayMachinesListHeaderIt,
  ...gatewayMachineListRowIt,
  ...sourcesInfoWithPopoverIt,
  ...searchIt,
  ...ticketCardIt,
  ...ticketListIt,
  ...ticketSupportForMachineRowIconButtonIt,
  ...tileIt,
  ...tileFormIt,
  ...tileDrawerModalIt,
  ...timeIntervalInputAndDropDownWrapperIt,
  ...timeSeriesDataTypeIt,
  ...timeSeriesLineNoDataIt,
  ...noDataInTimeframeIt,
  ...timestampsAndStringsDataTableIt,
  ...transferButtonIt,
  ...transferConfigurationToClientButtonIt,
  ...treeViewNoOurNodeMachineStructureDragAndDropIt,
  ...tsidContainerIt,
  ...twoFactorAuthenticationButtonsWrapperIt,
  ...unassignedFilterViewTitleIgnoreAllButtonWrapperIt,
  ...unitInputAndPopoverIt,
  ...unfilteredMissingNodesPillButtonIt,
  ...unsavedConditionMonitoringForNodeManagerNavigationModalIt,
  ...unsavedStructureForNodeManagerNavigationModalIt,
  ...unsavedStructureModalIt,
  ...userManagementListPillsNavIt,
  ...usersListIt,
  ...usersListViewIt,
  ...userStatusWithSwitchIt,
  ...validateUserDrawerInputsUtilIt,
  ...versionStringInfoIt,
  ...timezoneStringInfoIt,
  ...machinesRequestRemoteMachineAccessDrawerModalIt,
  ...machinesRemoteSupportActiveButtonIt,
  ...machinesRemoteSupportRequestedButtonIt,
  ...machinesCancelRequestDisconnectSupportModalIt,
  ...machinesCancelRequestCrossModalIt,
  ...vpnManagerByRolePageIt,
  ...machinesListIt,
  ...machinesListHeaderExpandCollapseAllIt,
  ...machinesListRowIt,
  ...machinesListWithCompaniesIt,
  ...vncCountdownBarIt,
  ...zendeskContactUrlIt,
  ...otaHistoryListIt,
  ...otaMachineHeaderIt,
  ...otaUpdateSummaryIt,
  ...otaModalIt,
  ...otaNavbarIt,
  ...otaHistoryIt,
  ...otaReleaseNotesIt,
  ...otaFirmwareVersionDrawerModalIt,
  ...otaDrawerFormIt,
  ...otaDrawerMarkDownSupportIt,
  ...dropAreaAddFirmwareIt,
  ...dropAreaAddImageIt,
  ...otaFirmwareBackupDrawerModalIt,
  ...otaDrawerInfoIt,
  ...otaConfigurationsDrawerModalIt,
  ...otaConfigurationBackupDrawerModalIt,
  ...otaConfigurationStartIt,
  ...otaFirmwareStartIt,
  ...otaDownloadModalIt,
  ...otaFirmwareInstallModalIt,
  ...otaPushFirmwareModalIt,
  ...otaCreateBackupModalIt,
  ...otaBackupProcessPendingApprovalByOperatorIt,
  ...otaBackupProcessReviewRequestAndApproveIt,
  ...otaBackupProcessRequestApprovalForAdminIt,
  ...otaConfirmBackupProcessModalIt,
  ...otaAcceptAndCreateBackupProcessModalIt,
  ...otaBackupProcessAcceptAndCreateIt,
  ...otaPushFirmwareBackupModalIt,
  ...otaFirmwareUploadModalIt,
  ...otaConfigurationUploadModalIt,
  ...otaEmptyPlaceholderIt,
  ...markdownSupportPopoverIt,
  ...ticketPageChatHeaderIt,
  ...ticketPatchUtilitiesContainerIt,
  ...patchTicketPriorityDropdownIt,
  ...patchTicketStatusDropdownIt,
  ...patchTicketAssigneesDropdownIt,
  ...nodeManagerNavigationButtonsIt,
  ...otaConfigurationInstallModalIt,
  ...otaBackupStartIt,
  ...otaAbortInstallIt,
  ...otaConfirmFirmwareInstallationModalIt,
  ...otaPendingApprovalByOperatorIt,
  ...otaFirmwareInstallationInProgressIt,
  ...otaBackupProcessInProgressIt,
  ...otaErrorBoxIt,
  ...otaInstallationInProgressModalIt,
  ...otaBackupProcessInProgressModalIt,
  ...otaInstallationCompleteModalIt,
  ...otaInstallationFailedModalIt,
  ...otaAcceptAndPushIt,
  ...otaAcceptAndPushFirmwareModalIt,
  ...otaRequestForApprovalIt,
  ...otaRequestApprovalForAdminIt,
  ...infoButtonIt,
  ...taskbarIt,
  ...ticketsTaskbarCardIt,
  ...taskbarTicketsHistoryPopoverIt,
  ...sseIt,
  ...supportChatModalIt,
  ...thingsHubSearchIt,
  ...thingsHubDragAndDropIt,
  ...filteredNodeOurNodeIt,
  ...datePickerIt,
  ...staticHeaderIt,
  ...staticTextIt,
  ...staticLinkIt,
  ...staticSeparatorIt,
  ...machineOverviewIt,
  ...shotDataLineChartIt,
  ...singleTextValueIt,
};

export const dutchModules = {
  ...ticketPatchUtilitiesContainerNl,
  ...patchTicketPriorityDropdownNl,
  ...patchTicketStatusDropdownNl,
  ...patchTicketAssigneesDropdownNl,
  ...nodeManagerNavigationButtonsNl,
  ...otaConfigurationInstallModalNl,
  ...otaBackupStartNl,
  ...otaAbortInstallNl,
  ...otaConfirmFirmwareInstallationModalNl,
  ...otaPendingApprovalByOperatorNl,
  ...otaFirmwareInstallationInProgressNl,
  ...otaBackupProcessInProgressNl,
  ...otaErrorBoxNl,
  ...otaInstallationInProgressModalNl,
  ...otaBackupProcessInProgressModalNl,
  ...otaInstallationCompleteModalNl,
  ...otaInstallationFailedModalNl,
  ...otaAcceptAndPushNl,
  ...otaAcceptAndPushFirmwareModalNl,
  ...otaRequestForApprovalNl,
  ...otaRequestApprovalForAdminNl,
  ...infoButtonNl,
  ...taskbarNl,
  ...ticketsTaskbarCardNl,
  ...taskbarTicketsHistoryPopoverNl,
  ...sseNl,
  ...supportChatModalNl,
  ...thingsHubSearchNl,
  ...thingsHubDragAndDropNl,
  ...filteredNodeOurNodeNl,
  ...factoryDashboardPageNl,
  ...machineOverviewContainerNl,
  ...machineOverviewContainerDrBoyNl,
  ...staticMachineOverviewContainerForTtNl,
  ...machinesListWithCompaniesNl,
  ...machinesListRowNl,
  ...machinesListHeaderExpandCollapseAllNl,
  ...machinesListNl,
  ...machinesCancelRequestCrossModalNl,
  ...machinesCancelRequestDisconnectSupportModalNl,
  ...machinesRemoteSupportRequestedButtonNl,
  ...machinesRemoteSupportActiveButtonNl,
  ...machinesRequestRemoteMachineAccessDrawerModalNl,
  ...serviceUsersListViewNl,
  ...addRequestTechnicalSupportDrawerModalWithoutMachineNl,
  ...addRequestTechnicalSupportDrawerModalNl,
  ...ticketPageChatHeaderNl,
  ...markdownSupportPopoverNl,
  ...otaEmptyPlaceholderNl,
  ...otaConfigurationUploadModalNl,
  ...otaFirmwareUploadModalNl,
  ...otaFirmwareInstallModalNl,
  ...otaPushFirmwareModalNl,
  ...otaCreateBackupModalNl,
  ...otaBackupProcessPendingApprovalByOperatorNl,
  ...otaBackupProcessReviewRequestAndApproveNl,
  ...otaBackupProcessRequestApprovalForAdminNl,
  ...otaConfirmBackupProcessModalNl,
  ...otaAcceptAndCreateBackupProcessModalNl,
  ...otaBackupProcessAcceptAndCreateNl,
  ...otaPushFirmwareBackupModalNl,
  ...otaDownloadModalNl,
  ...otaFirmwareStartNl,
  ...otaConfigurationStartNl,
  ...otaConfigurationBackupDrawerModalNl,
  ...otaConfigurationsDrawerModalNl,
  ...otaDrawerInfoNl,
  ...otaFirmwareBackupDrawerModalNl,
  ...dropAreaAddFirmwareNl,
  ...dropAreaAddImageNl,
  ...otaDrawerMarkDownSupportNl,
  ...otaDrawerFormNl,
  ...otaFirmwareVersionDrawerModalNl,
  ...otaReleaseNotesNl,
  ...otaHistoryNl,
  ...otaNavbarNl,
  ...otaModalNl,
  ...otaUpdateSummaryNl,
  ...otaMachineHeaderNl,
  ...otaHistoryListNl,
  ...zendeskContactUrlNl,
  ...vncCountdownBarNl,
  ...timezoneStringInfoNl,
  ...versionStringInfoNl,
  ...validateUserDrawerInputsUtilNl,
  ...userStatusWithSwitchNl,
  ...usersListViewNl,
  ...usersListNl,
  ...userManagementListPillsNavNl,
  ...unsavedStructureModalNl,
  ...unsavedStructureForNodeManagerNavigationModalNl,
  ...unsavedConditionMonitoringForNodeManagerNavigationModalNl,
  ...unfilteredMissingNodesPillButtonNl,
  ...unitInputAndPopoverNl,
  ...unassignedFilterViewTitleIgnoreAllButtonWrapperNl,
  ...twoFactorAuthenticationButtonsWrapperNl,
  ...tsidContainerNl,
  ...treeViewNoOurNodeMachineStructureDragAndDropNl,
  ...transferConfigurationToClientButtonNl,
  ...transferButtonNl,
  ...timestampsAndStringsDataTableNl,
  ...timeSeriesLineNoDataNl,
  ...noDataInTimeframeNl,
  ...timeSeriesDataTypeNl,
  ...timeIntervalInputAndDropDownWrapperNl,
  ...tileDrawerModalNl,
  ...tileFormNl,
  ...tileNl,
  ...ticketSupportForMachineRowIconButtonNl,
  ...ticketListNl,
  ...ticketCardNl,
  ...searchNl,
  ...sourcesInfoWithPopoverNl,
  ...gatewayMachineListRowNl,
  ...gatewayMachinesListHeaderNl,
  ...sourceInfoDrawerModalNl,
  ...snackbarNotificationsNl,
  ...smallBlueprintBannerAutoMatchNl,
  ...serviceUsersListNl,
  ...selectedTicketViewNl,
  ...selectedItemsHiddenTextNl,
  ...scanInterruptionModalNl,
  ...saveBlueprintModalNl,
  ...rolesDescriptionsPopoverNl,
  ...rolesSelectorNl,
  ...resolvedAllNodesPillButtonNl,
  ...replaceBlueprintModalNl,
  ...replaceBlueprintGradientBoxInfoContainerNl,
  ...replaceBlueprintGradientBoxDescriptionContainerNl,
  ...replaceBlueprintGradientBoxNl,
  ...renderUnreleasedFeaturesInfoNl,
  ...renderRestructuringSummaryNodesPillElementNl,
  ...renderOnlyForDevelopersInfoNl,
  ...readOnlyConnectedSourceViewNl,
  ...questionMarkWithPopoverForGatewaysNl,
  ...questionMarkWithPopoverForConditionMonitoringNl,
  ...questionMarkPopoverNl,
  ...pleaseWaitWhileProcessingNl,
  ...overwriteStructureWarningModalNl,
  ...dashboardTimeseriesInfoWithPopoverNl,
  ...ourNodeDetailsPanelNl,
  ...ourNodeAncestorsLineageTreeNl,
  ...oneShotNl,
  ...shotTableNl,
  ...nodeManagerInfoBarPillsNavNl,
  ...noMachinesDetectedViewNl,
  ...noGatewaysDetectedViewNl,
  ...nodesCounterSelectorNl,
  ...newTransferConfigurationToClientNl,
  ...navigationNl,
  ...adminPanelSidebarNl,
  ...organizationsViewAdminPanelNl,
  ...addMachineGroupsAdminPanelModalNl,
  ...machineGroupsViewAdminPanelNl,
  ...cleanupViewAdminPanelNl,
  ...machineGroupsListAdminPanelNl,
  ...machineGroupExpandedViewNl,
  ...organizationsTableAdminPanelNl,
  ...adminPanelPageNl,
  ...nameOurNodeNl,
  ...nameInputOurNodeNl,
  ...machineStructurePanelNl,
  ...machineStructurePanelControlBarNl,
  ...machineStructureFilterNl,
  ...logoutTimerNl,
  ...timezoneSelectorWithSearchNl,
  ...timezoneDateNl,
  ...languageSelectorWithSearchNl,
  ...initialStructureFilterNl,
  ...initialStructurePanelNl,
  ...infoIconAndTextNl,
  ...indicatorTextNl,
  ...iconButtonWithTextNl,
  ...iconButtonNl,
  ...helpButtonNl,
  ...gatewayServiceUsersListNl,
  ...gatewaysListViewNl,
  ...gatewaysListRowNl,
  ...gatewaysListHeaderNl,
  ...gatewayServiceUsersListViewNl,
  ...foundAllNodesPillBoxNl,
  ...findMyBlueprintLibraryModalNl,
  ...findAutoMatchBlueprintNl,
  ...filterIconNl,
  ...filteredMissingNodesPillButtonNl,
  ...errorPaneNl,
  ...enableDisableAllBlueprintDashboardTogglesNl,
  ...emptyTicketContainerTicketsPageNl,
  ...emptyTicketsInboxTicketsPageNl,
  ...editUserDrawerModalNl,
  ...editSourceNameNl,
  ...editServiceUserDrawerModalNl,
  ...editWidgetDrawerModalNl,
  ...multipleTextValuesNl,
  ...counterNumberNl,
  ...trendLineNl,
  ...multiLineNl,
  ...lookbackAndPollingFieldsNl,
  ...scaleInputNl,
  ...editGatewayNameNl,
  ...dropDownLanguageNl,
  ...dropAreaNl,
  ...drawerModalNl,
  ...drawerIconContainerNl,
  ...dragImageNl,
  ...dashboardPanelNl,
  ...dashboardGraphPanelContentNl,
  ...customerNamespaceStringNl,
  ...copyAccessTokenLinkNl,
  ...connectedGatewaysListContainerNl,
  ...checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertNl,
  ...checkedUnorderedListNl,
  ...checkBoxTextWrapperNl,
  ...buttonWithIconNl,
  ...bulkEditDataAcquisitionModalNl,
  ...blueprintUnassignedWarningIgnoreButtonWrapperNl,
  ...blueprintsTableNl,
  ...blueprintTableBodyFlexWrapperWithVerifiedIconNl,
  ...blueprintStateInfoBannerRestructuringSummaryWrapperNl,
  ...blueprintStateInfoBannerRestructuringCounterNl,
  ...blueprintStateInfoBannerModalsButtonsWrapperNl,
  ...blueprintStateInfoBannerDataAcquisitionSummaryWrapperNl,
  ...blueprintStateInfoBannerBlueprintNameVerifiedWrapperNl,
  ...blueprintStateInfoBannerAuthorDateWrapperNl,
  ...blueprintDescriptionPopoverNl,
  ...bigBlueprintBannerAutoMatchNl,
  ...bigBlueprintBannerNl,
  ...backIconButtonWithTextNl,
  ...autoTranslationButtonNl,
  ...applyMyBlueprintLibraryNl,
  ...applyAutoMatchBlueprintNl,
  ...alarmProfilesDrawerModalNl,
  ...alarmProfilePopoverNl,
  ...alarmProfileEmailRecipientsListNl,
  ...alarmProfileEmailRecipientsDrawerModalNl,
  ...alarmProfileCardNl,
  ...alarmNodeDetailsPanelNl,
  ...alarmListToolbarNl,
  ...alarmListNodeNl,
  ...alarmListHeaderNl,
  ...alarmListNl,
  ...userCredentialsModalNl,
  ...supportChatNl,
  ...aiRagChatNl,
  ...alarmsNotificationsDrawerModalNl,
  ...addUserDrawerModalNl,
  ...addServiceUserDrawerModalNl,
  ...autoGenerateCertificateSettingNl,
  ...addNewGatewayDrawerModalNl,
  ...addNewMachineDrawerModalNl,
  ...dashboardCardNl,
  ...dashboardThemeEditorNl,
  ...dashboardTileGridNl,
  ...machineOverviewWidgetNl,
  ...vpnManagerByRolePageNl,
  ...datePickerNl,
  ...staticHeaderNl,
  ...staticTextNl,
  ...staticLinkNl,
  ...staticSeparatorNl,
  ...machineOverviewNl,
  ...shotDataLineChartNl,
  ...singleTextValueNl,
};

export const turkishModules = {
  ...addServiceUserDrawerModalTr,
  ...dropAreaAddFirmwareTr,
  ...checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertTr,
  ...addUserDrawerModalTr,
  ...aiRagChatTr,
  ...alarmListHeaderTr,
  ...alarmListNodeTr,
  ...alarmListToolbarTr,
  ...alarmListTr,
  ...alarmNodeDetailsPanelTr,
  ...alarmsNotificationsDrawerModalTr,
  ...alarmProfileCardTr,
  ...alarmProfileEmailRecipientsDrawerModalTr,
  ...alarmProfileEmailRecipientsListTr,
  ...alarmProfilePopoverTr,
  ...alarmProfilesDrawerModalTr,
  ...applyAutoMatchBlueprintTr,
  ...applyMyBlueprintLibraryTr,
  ...autoGenerateCertificateSettingTr,
  ...autoTranslationButtonTr,
  ...backIconButtonWithTextTr,
  ...bigBlueprintBannerAutoMatchTr,
  ...bigBlueprintBannerTr,
  ...blueprintDescriptionPopoverTr,
  ...blueprintStateInfoBannerAuthorDateWrapperTr,
  ...blueprintStateInfoBannerBlueprintNameVerifiedWrapperTr,
  ...blueprintStateInfoBannerDataAcquisitionSummaryWrapperTr,
  ...blueprintStateInfoBannerModalsButtonsWrapperTr,
  ...blueprintStateInfoBannerRestructuringCounterTr,
  ...blueprintStateInfoBannerRestructuringSummaryWrapperTr,
  ...blueprintTableBodyFlexWrapperWithVerifiedIconTr,
  ...blueprintUnassignedWarningIgnoreButtonWrapperTr,
  ...blueprintsTableTr,
  ...bulkEditDataAcquisitionModalTr,
  ...buttonWithIconTr,
  ...checkBoxTextWrapperTr,
  ...checkedUnorderedListTr,
  ...connectedGatewaysListContainerTr,
  ...copyAccessTokenLinkTr,
  ...customerNamespaceStringTr,
  ...dashboardGraphPanelContentTr,
  ...dashboardPanelTr,
  ...dashboardTimeseriesInfoWithPopoverTr,
  ...datePickerTr,
  ...dragImageTr,
  ...drawerIconContainerTr,
  ...drawerModalTr,
  ...dropAreaTr,
  ...dropDownLanguageTr,
  ...editGatewayNameTr,
  ...editServiceUserDrawerModalTr,
  ...editSourceNameTr,
  ...editUserDrawerModalTr,
  ...emptyTicketContainerTicketsPageTr,
  ...emptyTicketsInboxTicketsPageTr,
  ...enableDisableAllBlueprintDashboardTogglesTr,
  ...errorPaneTr,
  ...factoryDashboardPageTr,
  ...filterIconTr,
  ...filteredNodeOurNodeTr,
  ...filteredMissingNodesPillButtonTr,
  ...findAutoMatchBlueprintTr,
  ...findMyBlueprintLibraryModalTr,
  ...foundAllNodesPillBoxTr,
  ...gatewayServiceUsersListViewTr,
  ...gatewayServiceUsersListTr,
  ...gatewaysListHeaderTr,
  ...gatewaysListRowTr,
  ...gatewaysListViewTr,
  ...helpButtonTr,
  ...iconButtonWithTextTr,
  ...iconButtonTr,
  ...indicatorTextTr,
  ...infoButtonTr,
  ...infoIconAndTextTr,
  ...initialStructureFilterTr,
  ...initialStructurePanelTr,
  ...logoutTimerTr,
  ...machineOverviewContainerTr,
  ...machineOverviewContainerDrBoyTr,
  ...staticMachineOverviewContainerForTtTr,
  ...machineStructureFilterTr,
  ...machineStructurePanelControlBarTr,
  ...machineStructurePanelTr,
  ...machinesCancelRequestCrossModalTr,
  ...machinesCancelRequestDisconnectSupportModalTr,
  ...machinesListHeaderExpandCollapseAllTr,
  ...vpnManagerByRolePageTr,
  ...machinesListRowTr,
  ...machinesListWithCompaniesTr,
  ...machinesListTr,
  ...machinesRemoteSupportActiveButtonTr,
  ...machinesRemoteSupportRequestedButtonTr,
  ...machinesRequestRemoteMachineAccessDrawerModalTr,
  ...serviceUsersListViewTr,
  ...markdownSupportPopoverTr,
  ...nameInputOurNodeTr,
  ...nameOurNodeTr,
  ...navigationTr,
  ...adminPanelSidebarTr,
  ...organizationsViewAdminPanelTr,
  ...addMachineGroupsAdminPanelModalTr,
  ...machineGroupsViewAdminPanelTr,
  ...cleanupViewAdminPanelTr,
  ...machineGroupsListAdminPanelTr,
  ...machineGroupExpandedViewTr,
  ...organizationsTableAdminPanelTr,
  ...adminPanelPageTr,
  ...newTransferConfigurationToClientTr,
  ...noGatewaysDetectedViewTr,
  ...noMachinesDetectedViewTr,
  ...nodeManagerInfoBarPillsNavTr,
  ...nodeManagerNavigationButtonsTr,
  ...nodesCounterSelectorTr,
  ...oneShotTr,
  ...shotTableTr,
  ...otaAbortInstallTr,
  ...otaBackupStartTr,
  ...otaBackupProcessInProgressTr,
  ...otaBackupProcessInProgressModalTr,
  ...otaConfigurationBackupDrawerModalTr,
  ...otaConfigurationsDrawerModalTr,
  ...otaConfigurationInstallModalTr,
  ...otaConfigurationStartTr,
  ...otaConfigurationUploadModalTr,
  ...otaCreateBackupModalTr,
  ...otaBackupProcessPendingApprovalByOperatorTr,
  ...otaDownloadModalTr,
  ...otaDrawerFormTr,
  ...otaDrawerInfoTr,
  ...otaDrawerMarkDownSupportTr,
  ...otaEmptyPlaceholderTr,
  ...otaFirmwareBackupDrawerModalTr,
  ...otaFirmwareInstallModalTr,
  ...otaFirmwareStartTr,
  ...otaFirmwareUploadModalTr,
  ...otaFirmwareVersionDrawerModalTr,
  ...otaHistoryListTr,
  ...otaHistoryTr,
  ...otaMachineHeaderTr,
  ...otaNavbarTr,
  ...otaReleaseNotesTr,
  ...otaUpdateSummaryTr,
  ...ourNodeAncestorsLineageTreeTr,
  ...ourNodeDetailsPanelTr,
  ...overwriteStructureWarningModalTr,
  ...patchTicketAssigneesDropdownTr,
  ...patchTicketPriorityDropdownTr,
  ...patchTicketStatusDropdownTr,
  ...pleaseWaitWhileProcessingTr,
  ...questionMarkPopoverTr,
  ...questionMarkWithPopoverForConditionMonitoringTr,
  ...questionMarkWithPopoverForGatewaysTr,
  ...readOnlyConnectedSourceViewTr,
  ...renderOnlyForDevelopersInfoTr,
  ...renderRestructuringSummaryNodesPillElementTr,
  ...renderUnreleasedFeaturesInfoTr,
  ...replaceBlueprintGradientBoxDescriptionContainerTr,
  ...replaceBlueprintGradientBoxInfoContainerTr,
  ...replaceBlueprintGradientBoxTr,
  ...replaceBlueprintModalTr,
  ...resolvedAllNodesPillButtonTr,
  ...rolesDescriptionsPopoverTr,
  ...rolesSelectorTr,
  ...saveBlueprintModalTr,
  ...scanInterruptionModalTr,
  ...searchTr,
  ...serviceUsersListTr,
  ...selectedItemsHiddenTextTr,
  ...selectedTicketViewTr,
  ...smallBlueprintBannerAutoMatchTr,
  ...snackbarNotificationsTr,
  ...sourceInfoDrawerModalTr,
  ...sourcesInfoWithPopoverTr,
  ...gatewayMachinesListHeaderTr,
  ...gatewayMachineListRowTr,
  ...sseTr,
  ...supportChatModalTr,
  ...supportChatTr,
  ...taskbarTicketsHistoryPopoverTr,
  ...taskbarTr,
  ...thingsHubDragAndDropTr,
  ...thingsHubSearchTr,
  ...ticketCardTr,
  ...ticketListTr,
  ...addRequestTechnicalSupportDrawerModalWithoutMachineTr,
  ...addRequestTechnicalSupportDrawerModalTr,
  ...ticketPageChatHeaderTr,
  ...ticketPatchUtilitiesContainerTr,
  ...ticketSupportForMachineRowIconButtonTr,
  ...ticketsTaskbarCardTr,
  ...tileDrawerModalTr,
  ...tileFormTr,
  ...tileTr,
  ...timeIntervalInputAndDropDownWrapperTr,
  ...timeSeriesDataTypeTr,
  ...timeSeriesLineNoDataTr,
  ...timestampsAndStringsDataTableTr,
  ...timezoneDateTr,
  ...timezoneSelectorWithSearchTr,
  ...timezoneStringInfoTr,
  ...transferButtonTr,
  ...transferConfigurationToClientButtonTr,
  ...treeViewNoOurNodeMachineStructureDragAndDropTr,
  ...tsidContainerTr,
  ...twoFactorAuthenticationButtonsWrapperTr,
  ...unassignedFilterViewTitleIgnoreAllButtonWrapperTr,
  ...unfilteredMissingNodesPillButtonTr,
  ...unitInputAndPopoverTr,
  ...unsavedConditionMonitoringForNodeManagerNavigationModalTr,
  ...unsavedStructureForNodeManagerNavigationModalTr,
  ...unsavedStructureModalTr,
  ...userCredentialsModalTr,
  ...userManagementListPillsNavTr,
  ...userStatusWithSwitchTr,
  ...usersListViewTr,
  ...usersListTr,
  ...validateUserDrawerInputsUtilTr,
  ...vncCountdownBarTr,
  ...zendeskContactUrlTr,
  ...otaAcceptAndPushTr,
  ...otaErrorBoxTr,
  ...otaConfirmFirmwareInstallationModalTr,
  ...otaFirmwareInstallationInProgressTr,
  ...otaInstallationCompleteModalTr,
  ...otaInstallationFailedModalTr,
  ...otaInstallationInProgressModalTr,
  ...otaPendingApprovalByOperatorTr,
  ...otaPushFirmwareModalTr,
  ...otaPushFirmwareBackupModalTr,
  ...otaRequestApprovalForAdminTr,
  ...otaRequestForApprovalTr,
  ...otaAcceptAndPushFirmwareModalTr,
  ...otaModalTr,
  ...otaAcceptAndCreateBackupProcessModalTr,
  ...otaBackupProcessAcceptAndCreateTr,
  ...otaBackupProcessRequestApprovalForAdminTr,
  ...otaBackupProcessReviewRequestAndApproveTr,
  ...otaConfirmBackupProcessModalTr,
  ...addNewGatewayDrawerModalTr,
  ...addNewMachineDrawerModalTr,
  ...dashboardCardTr,
  ...dashboardThemeEditorTr,
  ...dashboardTileGridTr,
  ...dropAreaAddImageTr,
  ...editWidgetDrawerModalTr,
  ...multipleTextValuesTr,
  ...counterNumberTr,
  ...trendLineTr,
  ...multiLineTr,
  ...lookbackAndPollingFieldsTr,
  ...scaleInputTr,
  ...machineOverviewWidgetTr,
  ...noDataInTimeframeTr,
  ...languageSelectorWithSearchTr,
  ...versionStringInfoTr,
  ...staticHeaderTr,
  ...staticTextTr,
  ...staticLinkTr,
  ...staticSeparatorTr,
  ...machineOverviewTr,
  ...shotDataLineChartTr,
  ...singleTextValueTr,
};
